// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: `${string}://${string}` | string & {};
};

export type ApiKey = {
    description?: string;
    expiresOnUtc?: Date;
    key: string;
    userId: string;
    id: string;
};

export type AssignPlatformRolesRequest = {
    roles?: Array<string> | null;
};

export type AssignRolesToOrganizationRequest = {
    roles?: Array<string> | null;
    userId: string;
};

export type AssociateCredentialMfaAuthenticatorForCallerRequest = {
    authenticatorType: CredentialMfaAuthenticatorType;
    mfaToken?: string | null;
    phoneNumber?: string | null;
};

export type AssociateCredentialMfaAuthenticatorForCallerResponse = {
    authenticator: CredentialMfaAuthenticatorAssociation;
};

export type Audit = {
    againstId?: string;
    auditCode: string;
    created: Date;
    messageTemplate: string;
    organizationId?: string;
    templateArguments: Array<string>;
    id: string;
};

export type AuthenticateCredentialRequest = {
    password: string;
    username: string;
};

export type AuthenticateResponse = {
    tokens: AuthenticateTokens;
};

export type AuthenticateSingleSignOnRequest = {
    authCode: string;
    code_verifier?: string | null;
    invitationToken?: string | null;
    provider: string;
    termsAndConditionsAccepted?: boolean | null;
};

export type AuthenticateTokens = {
    accessToken: AuthenticationToken;
    idToken?: AuthenticationToken;
    refreshToken: AuthenticationToken;
    userId: string;
};

export type AuthenticationToken = {
    expiresOn?: Date;
    type: TokenType;
    value: string;
};

export type Booking = {
    borrowerId: string;
    carId: string;
    endUtc: Date;
    startUtc: Date;
    id: string;
};

export type Car = {
    managers?: Array<CarManager>;
    manufacturer: CarManufacturer;
    owner: CarOwner;
    plate: CarLicensePlate;
    status?: string;
    id?: string;
};

export type CarLicensePlate = {
    jurisdiction: string;
    number: string;
};

export type CarManager = {
    id: string;
};

export type CarManufacturer = {
    make: string;
    model: string;
    year: number;
};

export type CarOwner = {
    id: string;
};

export type ChallengeCredentialMfaAuthenticatorForCallerRequest = {
    mfaToken: string;
};

export type ChallengeCredentialMfaAuthenticatorForCallerResponse = {
    challenge: CredentialMfaAuthenticatorChallenge;
};

export type ChangeCredentialMfaForCallerRequest = {
    isEnabled: boolean;
};

export type ChangeCredentialMfaResponse = {
    credential: PersonCredential;
};

export type ChangeDefaultOrganizationRequest = {
    organizationId: string;
};

export type ChangeOrganizationRequest = {
    name?: string | null;
};

export type ChangeProfileAvatarResponse = {
    profile: UserProfile;
};

export type ChangeProfileContactAddressRequest = {
    city?: string | null;
    countryCode?: string | null;
    line1?: string | null;
    line2?: string | null;
    line3?: string | null;
    state?: string | null;
    zip?: string | null;
};

export type ChangeProfileRequest = {
    displayName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    locale?: string | null;
    phoneNumber?: string | null;
    timezone?: string | null;
};

export type ChangeSubscriptionPlanRequest = {
    planId?: string | null;
};

export type ChargebeeEventContent = {
    customer: ChargebeeEventCustomer;
    subscription: ChargebeeEventSubscription;
};

export type ChargebeeEventCustomer = {
    id: string;
    payment_method?: ChargebeePaymentMethod;
};

export type ChargebeeEventSubscription = {
    billing_period?: number;
    billing_period_unit?: string;
    cancelled_at?: bigint;
    currency_code?: string;
    customer_id?: string;
    deleted?: boolean;
    id: string;
    next_billing_at?: bigint;
    status: string;
    subscription_items?: Array<ChargebeeEventSubscriptionItem>;
    trial_end?: bigint;
    trial_start?: bigint;
};

export type ChargebeeEventSubscriptionItem = {
    amount?: number;
    item_price_id?: string;
    item_type?: string;
    quantity?: number;
    unit_price?: number;
};

export type ChargebeeNotifyWebhookEventRequest = {
    content?: ChargebeeEventContent;
    event_type?: string | null;
    id?: string | null;
};

export type ChargebeePaymentMethod = {
    id: string;
    status: string;
    type: string;
};

export type CompletePasswordResetRequest = {
    password: string;
};

export type ConfirmCredentialMfaAuthenticatorForCallerRequest = {
    confirmationCode: string;
    mfaToken?: string | null;
    oobCode?: string | null;
};

export type ConfirmCredentialMfaAuthenticatorForCallerResponse = {
    authenticators?: Array<CredentialMfaAuthenticator>;
    tokens: AuthenticateTokens;
};

export type ConfirmEmailDeliveredRequest = {
    deliveredAtUtc?: Date | null;
    receiptId: string;
};

export type ConfirmEmailDeliveryFailedRequest = {
    failedAtUtc?: Date | null;
    reason?: string | null;
    receiptId: string;
};

export type ConfirmPersonCredentialRegistrationRequest = {
    token: string;
};

export type ConfirmSmsDeliveredRequest = {
    deliveredAtUtc?: Date | null;
    receiptId: string;
};

export type ConfirmSmsDeliveryFailedRequest = {
    failedAtUtc?: Date | null;
    reason?: string | null;
    receiptId: string;
};

export type ConsentOAuth2ClientForCallerRequest = {
    consented: boolean;
    redirectUri: string;
    scope: string;
    state?: string | null;
};

export type CreateApiKeyRequest = {
    expiresOnUtc?: Date | null;
};

export type CreateApiKeyResponse = {
    apiKey: string;
};

export type CreateOAuth2ClientRequest = {
    name: string;
    redirectUri?: string | null;
};

export type CreateOrganizationRequest = {
    name: string;
};

export type CredentialMfaAuthenticator = {
    isActive: boolean;
    type: CredentialMfaAuthenticatorType;
    id: string;
};

export type CredentialMfaAuthenticatorAssociation = {
    barCodeUri: string;
    oobCode: string;
    recoveryCodes?: Array<string>;
    secret: string;
    type: CredentialMfaAuthenticatorType;
};

export type CredentialMfaAuthenticatorChallenge = {
    oobCode: string;
    type: CredentialMfaAuthenticatorType;
};

export const CredentialMfaAuthenticatorType = {
    NONE: 'none',
    RECOVERY_CODES: 'recoveryCodes',
    OOB_SMS: 'oobSms',
    OOB_EMAIL: 'oobEmail',
    TOTP_AUTHENTICATOR: 'totpAuthenticator'
} as const;

export type CredentialMfaAuthenticatorType = typeof CredentialMfaAuthenticatorType[keyof typeof CredentialMfaAuthenticatorType];

export type CustomDto = {
    double?: number;
    enum?: CustomEnum;
    integer?: number;
    string: string;
    time?: Date;
};

export const CustomEnum = {
    NONE: 'none',
    ONE: 'one',
    TWENTY_ONE: 'twentyOne',
    ONE_HUNDRED_AND_ONE: 'oneHundredAndOne'
} as const;

export type CustomEnum = typeof CustomEnum[keyof typeof CustomEnum];

export type DeleteProfileAvatarResponse = {
    profile: UserProfile;
};

export type DeliverAuditRequest = {
    message: string;
};

export type DeliverMessageResponse = {
    isSent: boolean;
};

export type DeliverUsageRequest = {
    message: string;
};

export type DeliveredEmail = {
    attempts: Array<Date>;
    body: string;
    created: Date;
    deliveredAt?: Date;
    failedDeliveryAt?: Date;
    failedDeliveryReason?: string;
    isDelivered: boolean;
    isDeliveryFailed: boolean;
    isSent: boolean;
    organizationId?: string;
    sentAt?: Date;
    subject: string;
    tags: Array<string>;
    toDisplayName: string;
    toEmailAddress: string;
    id: string;
};

export type DeliveredSms = {
    attempts: Array<Date>;
    body: string;
    created: Date;
    deliveredAt?: Date;
    failedDeliveryAt?: Date;
    failedDeliveryReason?: string;
    isDelivered: boolean;
    isDeliveryFailed: boolean;
    isSent: boolean;
    organizationId?: string;
    sentAt?: Date;
    tags: Array<string>;
    toPhoneNumber: string;
    id: string;
};

export type DestroyAllRepositoriesRequest = {
    [key: string]: never;
};

export type DrainAllAuditsRequest = {
    [key: string]: never;
};

export type DrainAllEmailsRequest = {
    [key: string]: never;
};

export type DrainAllEventNotificationsRequest = {
    [key: string]: never;
};

export type DrainAllProvisioningsRequest = {
    [key: string]: never;
};

export type DrainAllSmsesRequest = {
    [key: string]: never;
};

export type DrainAllUsagesRequest = {
    [key: string]: never;
};

export type EmptyResponse = {
    [key: string]: never;
};

export type EndUser = {
    access: EndUserAccess;
    classification: EndUserClassification;
    features: Array<string>;
    roles: Array<string>;
    status: EndUserStatus;
    id: string;
};

export const EndUserAccess = { ENABLED: 'enabled', SUSPENDED: 'suspended' } as const;

export type EndUserAccess = typeof EndUserAccess[keyof typeof EndUserAccess];

export const EndUserClassification = { PERSON: 'person', MACHINE: 'machine' } as const;

export type EndUserClassification = typeof EndUserClassification[keyof typeof EndUserClassification];

export const EndUserStatus = { UNREGISTERED: 'unregistered', REGISTERED: 'registered' } as const;

export type EndUserStatus = typeof EndUserStatus[keyof typeof EndUserStatus];

export type EventNotification = {
    aggregateTypeFullName: string;
    eventJsonData: string;
    eventTypeFullName: string;
    lastPersistedAtUtc?: Date;
    streamName: string;
    version: number;
    id: string;
    subscriberRef: string;
};

export type ExchangeOAuth2ForTokensResponse = {
    access_token: string;
    expires_in: number;
    id_token?: string;
    refresh_token?: string;
    token_type: OAuth2TokenType;
};

export type ExportSubscriptionsToMigrateResponse = {
    metadata: SearchResultMetadata;
    subscriptions: Array<SubscriptionToMigrate>;
};

export const FakeBillingProviderEventType = { PAYMENT_METHOD_CREATED: 'paymentMethodCreated' } as const;

export type FakeBillingProviderEventType = typeof FakeBillingProviderEventType[keyof typeof FakeBillingProviderEventType];

export type FeatureFlag = {
    isEnabled: boolean;
    name: string;
};

export type Filtering = {
    fields: Array<string>;
};

export type FormatsTestingOnlyRequest = {
    custom?: CustomDto;
    double?: number | null;
    enum?: CustomEnum;
    integer?: number | null;
    string?: string | null;
    time?: Date | null;
};

export type FormatsTestingOnlyResponse = {
    custom: CustomDto;
    double?: number;
    enum?: CustomEnum;
    integer?: number;
    string: string;
    time?: Date;
};

export type GeneralTestingOnlyResponse = {
    a_camel_enum?: TestingOnlyEnum;
    a_camel_int?: number;
    a_camel_string?: string;
    anEnumProperty?: TestingOnlyEnum;
    anEnumQueryProperty?: TestingOnlyEnum;
    anEnumRouteProperty?: TestingOnlyEnum;
    anIntProperty?: number;
    anIntQueryProperty?: number;
    anIntRouteProperty?: number;
    aStringProperty: string;
    aStringQueryProperty: string;
    aStringRouteProperty: string;
};

export type GetAllFeatureFlagsResponse = {
    flags: Array<FeatureFlag>;
};

export type GetCallerTestingOnlyResponse = {
    callerId: string;
};

export type GetCarResponse = {
    car: Car;
};

export type GetDiscoveryDocumentResponse = {
    document: OpenIdConnectDiscoveryDocument;
};

export type GetFeatureFlagResponse = {
    flag: FeatureFlag;
};

export type GetIdentityResponse = {
    identity: Identity;
};

export type GetImageResponse = {
    image: Image;
};

export type GetJsonWebKeySetResponse = {
    keys: JsonWebKeySet;
};

export type GetOAuth2ClientConsentResponse = {
    consent: OAuth2ClientConsent;
};

export type GetOAuth2ClientConsentStatusResponse = {
    status: OAuth2ClientConsentStatus;
};

export type GetOAuth2ClientResponse = {
    client: OAuth2Client;
};

export type GetOAuth2ClientWithSecretsResponse = {
    client: OAuth2ClientWithSecrets;
};

export type GetOrganizationResponse = {
    organization: Organization;
};

export type GetOrganizationSettingsResponse = {
    organization: Organization;
    settings: {
        [key: string]: string;
    };
};

export type GetPersonCredentialRegistrationConfirmationResponse = {
    token: string;
};

export type GetProfileForCallerResponse = {
    profile: UserProfileForCaller;
};

export type GetProfileResponse = {
    profile: UserProfile;
};

export type GetSubscriptionResponse = {
    subscription: SubscriptionWithPlan;
};

export type GetTenantedTestingOnlyResponse = {
    organizationId: string;
};

export type GetUserInfoForCallerResponse = {
    user: OpenIdConnectUserInfo;
};

export type HealthCheckResponse = {
    name: string;
    status: string;
};

export type Identity = {
    hasCredentials: boolean;
    isMfaEnabled: boolean;
    id: string;
};

export type Image = {
    contentType: string;
    description?: string;
    filename?: string;
    url: string;
    id: string;
};

export type InitiatePasswordResetRequest = {
    emailAddress: string;
};

export type Invitation = {
    emailAddress: string;
    firstName: string;
    lastName?: string;
};

export type InviteGuestRequest = {
    email: string;
};

export type InviteGuestResponse = {
    invitation: Invitation;
};

export type InviteMemberToOrganizationRequest = {
    email?: string | null;
    userId?: string | null;
};

export type InviteMemberToOrganizationResponse = {
    organization: Organization;
};

export type Invoice = {
    amount?: number;
    currency: string;
    includesTax: boolean;
    invoicedOnUtc?: Date;
    lineItems: Array<InvoiceLineItem>;
    notes: Array<InvoiceNote>;
    payment?: InvoiceItemPayment;
    periodEndUtc?: Date;
    periodStartUtc?: Date;
    status: InvoiceStatus;
    taxAmount?: number;
    id: string;
};

export type InvoiceItemPayment = {
    amount?: number;
    currency: string;
    paidOnUtc?: Date;
    reference: string;
};

export type InvoiceLineItem = {
    amount?: number;
    currency: string;
    description: string;
    isTaxed: boolean;
    reference: string;
    taxAmount?: number;
};

export type InvoiceNote = {
    description: string;
};

export const InvoiceStatus = { UNPAID: 'unpaid', PAID: 'paid' } as const;

export type InvoiceStatus = typeof InvoiceStatus[keyof typeof InvoiceStatus];

export type InvoiceSummary = {
    amount: number;
    currency: string;
    nextUtc?: Date;
};

export type JsonWebKey = {
    alg: string;
    e?: string;
    k?: string;
    kid: string;
    kty: string;
    n?: string;
    use: string;
};

export type JsonWebKeySet = {
    keys: Array<JsonWebKey>;
};

export type ListCredentialMfaAuthenticatorsForCallerResponse = {
    authenticators: Array<CredentialMfaAuthenticator>;
};

export type ListMembersForOrganizationResponse = {
    metadata: SearchResultMetadata;
    members: Array<OrganizationMember>;
};

export type ListMembershipsForCallerResponse = {
    metadata: SearchResultMetadata;
    memberships: Array<Membership>;
};

export type ListPricingPlansResponse = {
    plans: PricingPlans;
};

export type MachineCredential = {
    apiKey: string;
    createdById: string;
    description?: string;
    expiresOnUtc?: Date;
    id: string;
};

export type MailgunDeliveryStatus = {
    description: string;
};

export type MailgunEventData = {
    'delivery-status'?: MailgunDeliveryStatus;
    event: string;
    id: string;
    message: MailgunMessage;
    reason: string;
    severity: string;
    timestamp?: number;
};

export type MailgunMessage = {
    headers: MailgunMessageHeaders;
};

export type MailgunMessageHeaders = {
    from: string;
    'message-id'?: string;
    subject: string;
    to: string;
};

export type MailgunNotifyWebhookEventRequest = {
    'event-data'?: MailgunEventData;
    signature?: MailgunSignature;
};

export type MailgunSignature = {
    signature: string;
    timestamp: string;
    token: string;
};

export type MakeBookingRequest = {
    /**
     * An ID of the Organization. If not provided, the ID of the default organization of the authenticated user (if any) is used
     */
    organizationId?: string | null;
    carId: string;
    endUtc?: Date | null;
    startUtc: Date;
};

export type MakeBookingResponse = {
    booking: Booking;
};

export type Membership = {
    features: Array<string>;
    isDefault: boolean;
    organizationId: string;
    ownership: OrganizationOwnership;
    roles: Array<string>;
    userId: string;
    id: string;
};

export type MigrateSubscriptionRequest = {
    providerName?: string | null;
    providerState?: {
        [key: string]: string;
    } | null;
};

export type MigrateSubscriptionResponse = {
    subscription: Subscription;
};

export type NotifyDomainEventRequest = {
    message: string;
    subscriptionName: string;
};

export type NotifyFakeBillingProviderWebHookEventRequest = {
    customerId?: string | null;
    eventId?: string | null;
    eventType?: FakeBillingProviderEventType;
};

export type NotifyProvisioningRequest = {
    message: string;
};

export type OAuth2Client = {
    logoUrl?: string;
    name: string;
    redirectUri?: string;
    id: string;
};

export type OAuth2ClientConsent = {
    clientId: string;
    isConsented: boolean;
    scopes: Array<string>;
    userId: string;
    id: string;
};

export type OAuth2ClientConsentStatus = {
    client: OAuth2Client;
    isConsented: boolean;
    scopes: Array<string>;
    userId: string;
};

export type OAuth2ClientWithSecret = {
    logoUrl?: string;
    name: string;
    redirectUri?: string;
    id: string;
    expiresOnUtc?: Date;
    secret: string;
};

export type OAuth2ClientWithSecrets = {
    logoUrl?: string;
    name: string;
    redirectUri?: string;
    id: string;
    secrets: Array<OAuthClientSecret>;
};

export const OAuth2GrantType = {
    AUTHORIZATION_CODE: 'authorization_Code',
    REFRESH_TOKEN: 'refresh_Token',
    CLIENT_CREDENTIALS: 'client_Credentials',
    PASSWORD: 'password',
    IMPLICIT: 'implicit'
} as const;

export type OAuth2GrantType = typeof OAuth2GrantType[keyof typeof OAuth2GrantType];

export const OAuth2ResponseType = {
    CODE: 'code',
    ID_TOKEN: 'id_Token',
    TOKEN: 'token'
} as const;

export type OAuth2ResponseType = typeof OAuth2ResponseType[keyof typeof OAuth2ResponseType];

export const OAuth2TokenType = { BEARER: 'bearer' } as const;

export type OAuth2TokenType = typeof OAuth2TokenType[keyof typeof OAuth2TokenType];

export type OAuthClientSecret = {
    expiresOnUtc?: Date;
    reference: string;
};

export type OpenApiPostTestingOnlyRequest = {
    /**
     * anoptionalfield
     */
    optionalField?: string | null;
    /**
     * arequiredfield
     */
    requiredField: string;
};

export type OpenApiPutTestingOnlyRequest = {
    /**
     * anoptionalfield
     */
    optionalField?: string | null;
    /**
     * arequiredfield
     */
    requiredField: string;
};

export type OpenApiResponseObject = {
    anAnnotatedRequiredField: string;
    anInitializedField: string;
    aNullableField?: string;
    aNullableValueTypeField?: boolean;
    aRequiredField: string;
    aValueTypeField: boolean;
};

export type OpenApiTestingOnlyResponse = {
    anAnnotatedRequiredField: string;
    anInitializedField: string;
    anNullableObject?: OpenApiResponseObject;
    aNullableField?: string;
    aNullableValueTypeField?: boolean;
    aRequiredField: string;
    aValueTypeField: boolean;
    message: string;
};

export const OpenIdConnectCodeChallengeMethod = { PLAIN: 'plain', S256: 's256' } as const;

export type OpenIdConnectCodeChallengeMethod = typeof OpenIdConnectCodeChallengeMethod[keyof typeof OpenIdConnectCodeChallengeMethod];

export type OpenIdConnectDiscoveryDocument = {
    authorizationEndpoint: string;
    claimsSupported: Array<string>;
    codeChallengeMethodsSupported: Array<string>;
    idTokenEncryptionAlgValuesSupported: Array<string>;
    idTokenSigningAlgValuesSupported: Array<string>;
    issuer: string;
    jwksUri: string;
    registrationEndPoint: string;
    responseTypesSupported: Array<string>;
    scopesSupported: Array<string>;
    subjectTypesSupported: Array<string>;
    tokenEndpoint: string;
    tokenEndpointAuthMethodsSupported: Array<string>;
    tokenEndpointAuthSigningAlgValuesSupported: Array<string>;
    userInfoEncryptionAlgValuesSupported: Array<string>;
    userInfoEndpoint: string;
    userInfoSigningAlgValuesSupported: Array<string>;
};

export type OpenIdConnectUserInfo = {
    address: ProfileAddress;
    email: string;
    email_verified?: boolean;
    family_name?: string;
    given_name?: string;
    locale: string;
    name: string;
    phone_number?: string;
    phone_number_verified?: boolean;
    picture: string;
    sub?: string;
    zoneinfo?: string;
};

export type Organization = {
    avatarUrl?: string;
    createdById: string;
    name: string;
    ownership: OrganizationOwnership;
    id: string;
};

export type OrganizationMember = {
    classification: UserProfileClassification;
    emailAddress?: string;
    features: Array<string>;
    isDefault: boolean;
    isOwner: boolean;
    isRegistered: boolean;
    name: PersonName;
    roles: Array<string>;
    userId: string;
    id: string;
};

export const OrganizationOwnership = { SHARED: 'shared', PERSONAL: 'personal' } as const;

export type OrganizationOwnership = typeof OrganizationOwnership[keyof typeof OrganizationOwnership];

export const PaymentMethodStatus = { INVALID: 'invalid', VALID: 'valid' } as const;

export type PaymentMethodStatus = typeof PaymentMethodStatus[keyof typeof PaymentMethodStatus];

export const PaymentMethodType = {
    NONE: 'none',
    CARD: 'card',
    OTHER: 'other'
} as const;

export type PaymentMethodType = typeof PaymentMethodType[keyof typeof PaymentMethodType];

export const PeriodFrequencyUnit = {
    ETERNITY: 'eternity',
    DAY: 'day',
    WEEK: 'week',
    MONTH: 'month',
    YEAR: 'year'
} as const;

export type PeriodFrequencyUnit = typeof PeriodFrequencyUnit[keyof typeof PeriodFrequencyUnit];

export type PersonCredential = {
    isMfaEnabled: boolean;
    user: EndUser;
    id: string;
};

export type PersonName = {
    firstName: string;
    lastName?: string;
};

export type PlanPeriod = {
    frequency: number;
    unit: PeriodFrequencyUnit;
};

export type PostInsecureTestingOnlyRequest = {
    [key: string]: never;
};

export type PostTestingOnlyRequest = {
    a_camel_enum?: TestingOnlyEnum;
    a_camel_int?: number | null;
    a_camel_string?: string | null;
    anEnumProperty?: TestingOnlyEnum;
    anEnumQueryProperty?: TestingOnlyEnum;
    anIntProperty?: number | null;
    anIntQueryProperty?: number | null;
    aStringProperty?: string | null;
    aStringQueryProperty?: string | null;
};

export type PostWithEmptyBodyAndRequiredPropertiesTestingOnlyRequest = {
    requiredField?: string | null;
};

export type PostWithEmptyBodyTestingOnlyRequest = {
    [key: string]: never;
};

export type PostWithRedirectTestingOnlyRequest = {
    result?: string | null;
};

export type PostWithRouteParamsAndEmptyBodyTestingOnlyRequest = {
    [key: string]: never;
};

export type PricingFeatureItem = {
    description: string;
    isIncluded: boolean;
};

export type PricingFeatureSection = {
    description?: string;
    features: Array<PricingFeatureItem>;
};

export type PricingPlan = {
    cost: number;
    currency: string;
    description?: string;
    displayName?: string;
    featureSection: Array<PricingFeatureSection>;
    isRecommended: boolean;
    notes?: string;
    period: PlanPeriod;
    setupCost: number;
    trial?: SubscriptionTrialPeriod;
    id: string;
};

export type PricingPlans = {
    annually: Array<PricingPlan>;
    daily: Array<PricingPlan>;
    eternally: Array<PricingPlan>;
    monthly: Array<PricingPlan>;
    weekly: Array<PricingPlan>;
};

export type ProblemDetails = {
    type: string;
    title: string;
    status?: number;
    detail: string;
    instance: string;
    [key: string]: unknown | string | number | undefined;
};

export type ProfileAddress = {
    city: string;
    countryCode?: string;
    line1: string;
    line2: string;
    line3: string;
    state: string;
    zip: string;
};

export type RecordMeasureRequest = {
    additional?: {
        [key: string]: unknown;
    } | null;
    eventName: string;
};

export type RecordUseRequest = {
    additional?: {
        [key: string]: unknown;
    } | null;
    eventName: string;
};

export type RefreshTokenRequest = {
    refreshToken: string;
};

export type RefreshTokenResponse = {
    tokens: AuthenticateTokens;
};

export type RegenerateOAuth2ClientSecretRequest = {
    [key: string]: never;
};

export type RegenerateOAuth2ClientSecretResponse = {
    client: OAuth2ClientWithSecret;
};

export type RegisterCarRequest = {
    /**
     * An ID of the Organization. If not provided, the ID of the default organization of the authenticated user (if any) is used
     */
    organizationId?: string | null;
    jurisdiction: string;
    make: string;
    model: string;
    numberPlate: string;
    year: number;
};

export type RegisterMachineRequest = {
    apiKeyExpiresOnUtc?: Date | null;
    countryCode?: string | null;
    name: string;
    timezone?: string | null;
};

export type RegisterMachineResponse = {
    machine: MachineCredential;
};

export type RegisterPersonCredentialRequest = {
    countryCode?: string | null;
    emailAddress: string;
    firstName: string;
    invitationToken?: string | null;
    lastName: string;
    locale?: string | null;
    password: string;
    termsAndConditionsAccepted?: boolean;
    timezone?: string | null;
};

export type RegisterPersonCredentialResponse = {
    person: PersonCredential;
};

export type ResendGuestInvitationRequest = {
    [key: string]: never;
};

export type ResendPasswordResetRequest = {
    [key: string]: never;
};

export type ResendPersonCredentialRegistrationConfirmationRequest = {
    token: string;
};

export type ResetCredentialMfaRequest = {
    userId?: string | null;
};

export type ScheduleMaintenanceCarRequest = {
    /**
     * An ID of the Organization. If not provided, the ID of the default organization of the authenticated user (if any) is used
     */
    organizationId?: string | null;
    fromUtc?: Date;
    toUtc?: Date;
};

export type SearchAllApiKeysResponse = {
    metadata: SearchResultMetadata;
    keys: Array<ApiKey>;
};

export type SearchAllAuditsResponse = {
    metadata: SearchResultMetadata;
    audits: Array<Audit>;
};

export type SearchAllBookingsResponse = {
    metadata: SearchResultMetadata;
    bookings: Array<Booking>;
};

export type SearchAllCarUnavailabilitiesResponse = {
    metadata: SearchResultMetadata;
    unavailabilities: Array<Unavailability>;
};

export type SearchAllCarsResponse = {
    metadata: SearchResultMetadata;
    cars: Array<Car>;
};

export type SearchAllEmailDeliveriesResponse = {
    metadata: SearchResultMetadata;
    emails: Array<DeliveredEmail>;
};

export type SearchAllEventNotificationsResponse = {
    metadata: SearchResultMetadata;
    notifications: Array<EventNotification>;
};

export type SearchAllOAuth2ClientsResponse = {
    metadata: SearchResultMetadata;
    clients: Array<OAuth2Client>;
};

export type SearchAllSmsDeliveriesResponse = {
    metadata: SearchResultMetadata;
    smses: Array<DeliveredSms>;
};

export type SearchResultMetadata = {
    filter: Filtering;
    limit: number;
    offset: number;
    sort: Sorting;
    total: number;
};

export type SearchSubscriptionHistoryResponse = {
    metadata: SearchResultMetadata;
    invoices: Array<Invoice>;
};

export type SearchTestingOnlyResponse = {
    metadata: SearchResultMetadata;
    a_camel_enum?: TestingOnlyEnum;
    a_camel_int?: number;
    a_camel_string?: string;
    anEnumProperty?: TestingOnlyEnum;
    anEnumQueryProperty?: TestingOnlyEnum;
    anEnumRouteProperty?: TestingOnlyEnum;
    anIntProperty?: number;
    anIntQueryProperty?: number;
    anIntRouteProperty?: number;
    aStringProperty: string;
    aStringQueryProperty: string;
    aStringRouteProperty: string;
    items?: Array<TestResource>;
};

export type SendEmailRequest = {
    message: string;
};

export type SendGridEvent = {
    asm_group_id?: number;
    bounce_classification?: string;
    category?: Array<string>;
    email: string;
    event?: TwilioEmailDeliveryEvent;
    ip: string;
    reason: string;
    receipt_id?: string;
    response: string;
    sg_event_id?: string;
    sg_message_id?: string;
    'smtp-id'?: string;
    status: string;
    timestamp?: bigint;
    url: string;
    useragent: string;
};

export type SendSmsRequest = {
    message: string;
};

export const SortDirection = { ASCENDING: 'ascending', DESCENDING: 'descending' } as const;

export type SortDirection = typeof SortDirection[keyof typeof SortDirection];

export type Sorting = {
    by: string;
    direction: SortDirection;
};

export type StatusesPostTestingOnlyRequest = {
    [key: string]: never;
};

export type StatusesPostWithLocationTestingOnlyRequest = {
    [key: string]: never;
};

export type StatusesPutPatchTestingOnlyRequest = {
    [key: string]: never;
};

export type StatusesTestingOnlyResponse = {
    message: string;
};

export type StatusesTestingOnlySearchResponse = {
    messages: Array<string>;
    metadata: SearchResultMetadata;
};

export type StringMessageTestingOnlyResponse = {
    message: string;
};

export type Subscription = {
    buyerId: string;
    owningEntityId: string;
    providerName?: string;
    providerState: {
        [key: string]: string;
    };
    id: string;
};

export type SubscriptionPaymentMethod = {
    expiresOn?: Date;
    status: PaymentMethodStatus;
    type: PaymentMethodType;
};

export type SubscriptionPlan = {
    id: string;
    isTrial: boolean;
    tier: SubscriptionTier;
    trialEndDateUtc?: Date;
};

export const SubscriptionStatus = {
    UNSUBSCRIBED: 'unsubscribed',
    ACTIVATED: 'activated',
    CANCELED: 'canceled',
    CANCELING: 'canceling'
} as const;

export type SubscriptionStatus = typeof SubscriptionStatus[keyof typeof SubscriptionStatus];

export const SubscriptionTier = {
    UNSUBSCRIBED: 'unsubscribed',
    STANDARD: 'standard',
    PROFESSIONAL: 'professional',
    ENTERPRISE: 'enterprise'
} as const;

export type SubscriptionTier = typeof SubscriptionTier[keyof typeof SubscriptionTier];

export type SubscriptionToMigrate = {
    buyerId: string;
    owningEntityId: string;
    providerName?: string;
    providerState: {
        [key: string]: string;
    };
    id: string;
    buyer: {
        [key: string]: string;
    };
};

export type SubscriptionTrialPeriod = {
    frequency: number;
    hasTrial: boolean;
    unit: PeriodFrequencyUnit;
};

export type SubscriptionWithPlan = {
    buyerId: string;
    owningEntityId: string;
    providerName?: string;
    providerState: {
        [key: string]: string;
    };
    id: string;
    buyerReference: string;
    canBeCanceled: boolean;
    canBeUnsubscribed: boolean;
    canceledDateUtc?: Date;
    invoice: InvoiceSummary;
    paymentMethod: SubscriptionPaymentMethod;
    period: PlanPeriod;
    plan: SubscriptionPlan;
    status: SubscriptionStatus;
    subscriptionReference?: string;
};

export type TakeOfflineCarRequest = {
    /**
     * An ID of the Organization. If not provided, the ID of the default organization of the authenticated user (if any) is used
     */
    organizationId?: string | null;
    fromUtc?: Date | null;
    toUtc?: Date | null;
};

export type TestResource = {
    aProperty?: string;
    id: string;
};

export const TestingOnlyEnum = {
    VALUE1: 'value1',
    VALUE2: 'value2',
    VALUE3: 'value3',
    VALUE4: 'value4'
} as const;

export type TestingOnlyEnum = typeof TestingOnlyEnum[keyof typeof TestingOnlyEnum];

export const TokenType = {
    OTHER_TOKEN: 'otherToken',
    ACCESS_TOKEN: 'accessToken',
    REFRESH_TOKEN: 'refreshToken'
} as const;

export type TokenType = typeof TokenType[keyof typeof TokenType];

export type TransferSubscriptionRequest = {
    userId?: string | null;
};

export const TwilioEmailDeliveryEvent = {
    UNKNOWN: 'unknown',
    BOUNCE: 'bounce',
    BOUNCED: 'bounced',
    DELIVERED: 'delivered',
    DEFERRED: 'deferred',
    DROPPED: 'dropped',
    PROCESSED: 'processed',
    SPAMREPORT: 'spamreport',
    UNSUBSCRIBE: 'unsubscribe',
    GROUP_UNSUBSCRIBE: 'group_unsubscribe',
    GROUP_RESUBSCRIBE: 'group_resubscribe'
} as const;

export type TwilioEmailDeliveryEvent = typeof TwilioEmailDeliveryEvent[keyof typeof TwilioEmailDeliveryEvent];

export const TwilioSmsMessageStatus = {
    UNKNOWN: 'unknown',
    QUEUED: 'queued',
    SENDING: 'sending',
    SENT: 'sent',
    FAILED: 'failed',
    DELIVERED: 'delivered',
    UNDELIVERED: 'undelivered',
    RECEIVING: 'receiving',
    RECEIVED: 'received',
    ACCEPTED: 'accepted',
    SCHEDULED: 'scheduled',
    READ: 'read',
    CANCELED: 'canceled'
} as const;

export type TwilioSmsMessageStatus = typeof TwilioSmsMessageStatus[keyof typeof TwilioSmsMessageStatus];

export type UnInviteMemberFromOrganizationResponse = {
    organization: Organization;
};

export type UnassignPlatformRolesRequest = {
    roles?: Array<string> | null;
};

export type UnassignRolesFromOrganizationRequest = {
    roles?: Array<string> | null;
    userId: string;
};

export type Unavailability = {
    carId: string;
    causedByReason: string;
    causedByReference?: string;
    id: string;
};

export type UpdateImageRequest = {
    description?: string | null;
};

export type UpdateImageResponse = {
    image: Image;
};

export type UpdateOAuth2ClientRequest = {
    name?: string | null;
    redirectUri?: string | null;
};

export type UpdateUserResponse = {
    user: EndUser;
};

export type UploadImageResponse = {
    image: Image;
};

export type UserProfile = {
    address: ProfileAddress;
    avatarUrl?: string;
    classification: UserProfileClassification;
    displayName: string;
    emailAddress?: string;
    locale?: string;
    name: PersonName;
    phoneNumber?: string;
    timezone?: string;
    userId: string;
    id: string;
};

export const UserProfileClassification = { PERSON: 'person', MACHINE: 'machine' } as const;

export type UserProfileClassification = typeof UserProfileClassification[keyof typeof UserProfileClassification];

export type UserProfileForCaller = {
    address: ProfileAddress;
    avatarUrl?: string;
    classification: UserProfileClassification;
    displayName: string;
    emailAddress?: string;
    locale?: string;
    name: PersonName;
    phoneNumber?: string;
    timezone?: string;
    userId: string;
    id: string;
    defaultOrganizationId: string;
    features: Array<string>;
    isAuthenticated: boolean;
    roles: Array<string>;
};

export type ValidationsValidatedPostTestingOnlyRequest = {
    optionalField?: string | null;
    requiredField: string;
};

export type VerifyCredentialMfaAuthenticatorForCallerRequest = {
    confirmationCode: string;
    mfaToken: string;
    oobCode?: string | null;
};

export type VerifyGuestInvitationResponse = {
    invitation: Invitation;
};

export type Void = {
    [key: string]: never;
};

export type SearchAllApiKeysForCallerData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * An ID of the Organization. If not provided, the ID of the default organization of the authenticated user (if any) is used
         */
        OrganizationId?: string;
        /**
         * List of child resources to embed in the resource
         */
        Embed?: string;
        /**
         * List of fields to include and exclude in the search result
         */
        Filter?: string;
        /**
         * The maximum number of search results to return
         */
        Limit?: number;
        /**
         * The zero-based index of the first search result
         */
        Offset?: number;
        /**
         * List of fields to sort the results on
         */
        Sort?: string;
    };
    url: '/apikeys';
};

export type SearchAllApiKeysForCallerErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type SearchAllApiKeysForCallerError = SearchAllApiKeysForCallerErrors[keyof SearchAllApiKeysForCallerErrors];

export type SearchAllApiKeysForCallerResponses = {
    /**
     * OK
     */
    200: SearchAllApiKeysResponse;
};

export type SearchAllApiKeysForCallerResponse = SearchAllApiKeysForCallerResponses[keyof SearchAllApiKeysForCallerResponses];

export type CreateApiKeyData = {
    body?: CreateApiKeyRequest;
    path?: never;
    query?: never;
    url: '/apikeys';
};

export type CreateApiKeyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type CreateApiKeyError = CreateApiKeyErrors[keyof CreateApiKeyErrors];

export type CreateApiKeyResponses = {
    /**
     * Created
     */
    201: CreateApiKeyResponse;
};

export type CreateApiKeyResponse2 = CreateApiKeyResponses[keyof CreateApiKeyResponses];

export type DeleteApiKeyData = {
    body?: never;
    path: {
        Id: string;
    };
    query?: never;
    url: '/apikeys/{Id}';
};

export type DeleteApiKeyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type DeleteApiKeyError = DeleteApiKeyErrors[keyof DeleteApiKeyErrors];

export type DeleteApiKeyResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteApiKeyResponse = DeleteApiKeyResponses[keyof DeleteApiKeyResponses];

export type RevokeApiKeyData = {
    body?: never;
    path: {
        Id: string;
    };
    query?: never;
    url: '/apikeys/{Id}/revoke';
};

export type RevokeApiKeyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type RevokeApiKeyError = RevokeApiKeyErrors[keyof RevokeApiKeyErrors];

export type RevokeApiKeyResponses = {
    /**
     * No Content
     */
    204: void;
};

export type RevokeApiKeyResponse = RevokeApiKeyResponses[keyof RevokeApiKeyResponses];

export type DeliverAuditData = {
    body?: DeliverAuditRequest;
    path?: never;
    query?: never;
    url: '/audits/deliver';
};

export type DeliverAuditErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type DeliverAuditError = DeliverAuditErrors[keyof DeliverAuditErrors];

export type DeliverAuditResponses = {
    /**
     * Created
     */
    201: DeliverMessageResponse;
};

export type DeliverAuditResponse = DeliverAuditResponses[keyof DeliverAuditResponses];

export type DrainAllAuditsData = {
    body?: DrainAllAuditsRequest;
    path?: never;
    query?: never;
    url: '/audits/drain';
};

export type DrainAllAuditsErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type DrainAllAuditsError = DrainAllAuditsErrors[keyof DrainAllAuditsErrors];

export type DrainAllAuditsResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type DrainAllAuditsResponse = DrainAllAuditsResponses[keyof DrainAllAuditsResponses];

export type SearchAllAuditsData = {
    body?: never;
    path?: never;
    query?: {
        OrganizationId?: string;
        SinceUtc?: string;
        /**
         * List of child resources to embed in the resource
         */
        Embed?: string;
        /**
         * List of fields to include and exclude in the search result
         */
        Filter?: string;
        /**
         * The maximum number of search results to return
         */
        Limit?: number;
        /**
         * The zero-based index of the first search result
         */
        Offset?: number;
        /**
         * List of fields to sort the results on
         */
        Sort?: string;
    };
    url: '/audits';
};

export type SearchAllAuditsErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type SearchAllAuditsError = SearchAllAuditsErrors[keyof SearchAllAuditsErrors];

export type SearchAllAuditsResponses = {
    /**
     * OK
     */
    200: SearchAllAuditsResponse;
};

export type SearchAllAuditsResponse2 = SearchAllAuditsResponses[keyof SearchAllAuditsResponses];

export type RefreshTokenData = {
    body?: RefreshTokenRequest;
    path?: never;
    query?: never;
    url: '/tokens/refresh';
};

export type RefreshTokenErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * The refresh token has expired
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * The user's account is suspended or disabled, and cannot be authenticated or used
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type RefreshTokenError = RefreshTokenErrors[keyof RefreshTokenErrors];

export type RefreshTokenResponses = {
    /**
     * Created
     */
    201: RefreshTokenResponse;
};

export type RefreshTokenResponse2 = RefreshTokenResponses[keyof RefreshTokenResponses];

export type RevokeRefreshTokenData = {
    body?: never;
    path: {
        RefreshToken: string;
    };
    query?: never;
    url: '/tokens/{RefreshToken}';
};

export type RevokeRefreshTokenErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type RevokeRefreshTokenError = RevokeRefreshTokenErrors[keyof RevokeRefreshTokenErrors];

export type RevokeRefreshTokenResponses = {
    /**
     * No Content
     */
    204: void;
};

export type RevokeRefreshTokenResponse = RevokeRefreshTokenResponses[keyof RevokeRefreshTokenResponses];

export type ExportSubscriptionsToMigrateData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * List of child resources to embed in the resource
         */
        Embed?: string;
        /**
         * List of fields to include and exclude in the search result
         */
        Filter?: string;
        /**
         * The maximum number of search results to return
         */
        Limit?: number;
        /**
         * The zero-based index of the first search result
         */
        Offset?: number;
        /**
         * List of fields to sort the results on
         */
        Sort?: string;
    };
    url: '/subscriptions/export';
};

export type ExportSubscriptionsToMigrateErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ExportSubscriptionsToMigrateError = ExportSubscriptionsToMigrateErrors[keyof ExportSubscriptionsToMigrateErrors];

export type ExportSubscriptionsToMigrateResponses = {
    /**
     * OK
     */
    200: ExportSubscriptionsToMigrateResponse;
};

export type ExportSubscriptionsToMigrateResponse2 = ExportSubscriptionsToMigrateResponses[keyof ExportSubscriptionsToMigrateResponses];

export type MigrateSubscriptionPatchData = {
    body?: MigrateSubscriptionRequest;
    path: {
        Id: string;
    };
    query?: never;
    url: '/subscriptions/{Id}/migrate';
};

export type MigrateSubscriptionPatchErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type MigrateSubscriptionPatchError = MigrateSubscriptionPatchErrors[keyof MigrateSubscriptionPatchErrors];

export type MigrateSubscriptionPatchResponses = {
    /**
     * Accepted
     */
    202: MigrateSubscriptionResponse;
};

export type MigrateSubscriptionPatchResponse = MigrateSubscriptionPatchResponses[keyof MigrateSubscriptionPatchResponses];

export type MigrateSubscriptionPutData = {
    body?: MigrateSubscriptionRequest;
    path: {
        Id: string;
    };
    query?: never;
    url: '/subscriptions/{Id}/migrate';
};

export type MigrateSubscriptionPutErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type MigrateSubscriptionPutError = MigrateSubscriptionPutErrors[keyof MigrateSubscriptionPutErrors];

export type MigrateSubscriptionPutResponses = {
    /**
     * Accepted
     */
    202: MigrateSubscriptionResponse;
};

export type MigrateSubscriptionPutResponse = MigrateSubscriptionPutResponses[keyof MigrateSubscriptionPutResponses];

export type CancelBookingData = {
    body?: never;
    path: {
        Id: string;
    };
    query?: {
        /**
         * An ID of the Organization. If not provided, the ID of the default organization of the authenticated user (if any) is used
         */
        OrganizationId?: string;
    };
    url: '/bookings/{Id}';
};

export type CancelBookingErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type CancelBookingError = CancelBookingErrors[keyof CancelBookingErrors];

export type CancelBookingResponses = {
    /**
     * No Content
     */
    204: void;
};

export type CancelBookingResponse = CancelBookingResponses[keyof CancelBookingResponses];

export type SearchAllBookingsData = {
    body?: never;
    path?: never;
    query?: {
        FromUtc?: string;
        ToUtc?: string;
        /**
         * An ID of the Organization. If not provided, the ID of the default organization of the authenticated user (if any) is used
         */
        OrganizationId?: string;
        /**
         * List of child resources to embed in the resource
         */
        Embed?: string;
        /**
         * List of fields to include and exclude in the search result
         */
        Filter?: string;
        /**
         * The maximum number of search results to return
         */
        Limit?: number;
        /**
         * The zero-based index of the first search result
         */
        Offset?: number;
        /**
         * List of fields to sort the results on
         */
        Sort?: string;
    };
    url: '/bookings';
};

export type SearchAllBookingsErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type SearchAllBookingsError = SearchAllBookingsErrors[keyof SearchAllBookingsErrors];

export type SearchAllBookingsResponses = {
    /**
     * OK
     */
    200: SearchAllBookingsResponse;
};

export type SearchAllBookingsResponse2 = SearchAllBookingsResponses[keyof SearchAllBookingsResponses];

export type MakeBookingData = {
    body?: MakeBookingRequest;
    path?: never;
    query?: never;
    url: '/bookings';
};

export type MakeBookingErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type MakeBookingError = MakeBookingErrors[keyof MakeBookingErrors];

export type MakeBookingResponses = {
    /**
     * Created
     */
    201: MakeBookingResponse;
};

export type MakeBookingResponse2 = MakeBookingResponses[keyof MakeBookingResponses];

export type DeleteCarData = {
    body?: never;
    path: {
        Id: string;
    };
    query?: {
        /**
         * An ID of the Organization. If not provided, the ID of the default organization of the authenticated user (if any) is used
         */
        OrganizationId?: string;
    };
    url: '/cars/{Id}';
};

export type DeleteCarErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type DeleteCarError = DeleteCarErrors[keyof DeleteCarErrors];

export type DeleteCarResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteCarResponse = DeleteCarResponses[keyof DeleteCarResponses];

export type GetCarData = {
    body?: never;
    path: {
        Id: string;
    };
    query?: {
        /**
         * An ID of the Organization. If not provided, the ID of the default organization of the authenticated user (if any) is used
         */
        OrganizationId?: string;
    };
    url: '/cars/{Id}';
};

export type GetCarErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type GetCarError = GetCarErrors[keyof GetCarErrors];

export type GetCarResponses = {
    /**
     * OK
     */
    200: GetCarResponse;
};

export type GetCarResponse2 = GetCarResponses[keyof GetCarResponses];

export type SearchAllCarsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * An ID of the Organization. If not provided, the ID of the default organization of the authenticated user (if any) is used
         */
        OrganizationId?: string;
        /**
         * List of child resources to embed in the resource
         */
        Embed?: string;
        /**
         * List of fields to include and exclude in the search result
         */
        Filter?: string;
        /**
         * The maximum number of search results to return
         */
        Limit?: number;
        /**
         * The zero-based index of the first search result
         */
        Offset?: number;
        /**
         * List of fields to sort the results on
         */
        Sort?: string;
    };
    url: '/cars';
};

export type SearchAllCarsErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type SearchAllCarsError = SearchAllCarsErrors[keyof SearchAllCarsErrors];

export type SearchAllCarsResponses = {
    /**
     * OK
     */
    200: SearchAllCarsResponse;
};

export type SearchAllCarsResponse2 = SearchAllCarsResponses[keyof SearchAllCarsResponses];

export type RegisterCarData = {
    body?: RegisterCarRequest;
    path?: never;
    query?: never;
    url: '/cars';
};

export type RegisterCarErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type RegisterCarError = RegisterCarErrors[keyof RegisterCarErrors];

export type RegisterCarResponses = {
    /**
     * Created
     */
    201: GetCarResponse;
};

export type RegisterCarResponse = RegisterCarResponses[keyof RegisterCarResponses];

export type ScheduleMaintenanceCarPatchData = {
    body?: ScheduleMaintenanceCarRequest;
    path: {
        Id: string;
    };
    query?: never;
    url: '/cars/{Id}/maintain';
};

export type ScheduleMaintenanceCarPatchErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ScheduleMaintenanceCarPatchError = ScheduleMaintenanceCarPatchErrors[keyof ScheduleMaintenanceCarPatchErrors];

export type ScheduleMaintenanceCarPatchResponses = {
    /**
     * Accepted
     */
    202: GetCarResponse;
};

export type ScheduleMaintenanceCarPatchResponse = ScheduleMaintenanceCarPatchResponses[keyof ScheduleMaintenanceCarPatchResponses];

export type ScheduleMaintenanceCarPutData = {
    body?: ScheduleMaintenanceCarRequest;
    path: {
        Id: string;
    };
    query?: never;
    url: '/cars/{Id}/maintain';
};

export type ScheduleMaintenanceCarPutErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ScheduleMaintenanceCarPutError = ScheduleMaintenanceCarPutErrors[keyof ScheduleMaintenanceCarPutErrors];

export type ScheduleMaintenanceCarPutResponses = {
    /**
     * Accepted
     */
    202: GetCarResponse;
};

export type ScheduleMaintenanceCarPutResponse = ScheduleMaintenanceCarPutResponses[keyof ScheduleMaintenanceCarPutResponses];

export type SearchAllAvailableCarsData = {
    body?: never;
    path?: never;
    query?: {
        FromUtc?: string;
        ToUtc?: string;
        /**
         * An ID of the Organization. If not provided, the ID of the default organization of the authenticated user (if any) is used
         */
        OrganizationId?: string;
        /**
         * List of child resources to embed in the resource
         */
        Embed?: string;
        /**
         * List of fields to include and exclude in the search result
         */
        Filter?: string;
        /**
         * The maximum number of search results to return
         */
        Limit?: number;
        /**
         * The zero-based index of the first search result
         */
        Offset?: number;
        /**
         * List of fields to sort the results on
         */
        Sort?: string;
    };
    url: '/cars/available';
};

export type SearchAllAvailableCarsErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type SearchAllAvailableCarsError = SearchAllAvailableCarsErrors[keyof SearchAllAvailableCarsErrors];

export type SearchAllAvailableCarsResponses = {
    /**
     * OK
     */
    200: SearchAllCarsResponse;
};

export type SearchAllAvailableCarsResponse = SearchAllAvailableCarsResponses[keyof SearchAllAvailableCarsResponses];

export type SearchAllCarUnavailabilitiesData = {
    body?: never;
    path: {
        Id: string;
    };
    query?: {
        /**
         * An ID of the Organization. If not provided, the ID of the default organization of the authenticated user (if any) is used
         */
        OrganizationId?: string;
        /**
         * List of child resources to embed in the resource
         */
        Embed?: string;
        /**
         * List of fields to include and exclude in the search result
         */
        Filter?: string;
        /**
         * The maximum number of search results to return
         */
        Limit?: number;
        /**
         * The zero-based index of the first search result
         */
        Offset?: number;
        /**
         * List of fields to sort the results on
         */
        Sort?: string;
    };
    url: '/cars/{Id}/unavailabilities';
};

export type SearchAllCarUnavailabilitiesErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type SearchAllCarUnavailabilitiesError = SearchAllCarUnavailabilitiesErrors[keyof SearchAllCarUnavailabilitiesErrors];

export type SearchAllCarUnavailabilitiesResponses = {
    /**
     * OK
     */
    200: SearchAllCarUnavailabilitiesResponse;
};

export type SearchAllCarUnavailabilitiesResponse2 = SearchAllCarUnavailabilitiesResponses[keyof SearchAllCarUnavailabilitiesResponses];

export type TakeOfflineCarPatchData = {
    body?: TakeOfflineCarRequest;
    path: {
        Id: string;
    };
    query?: never;
    url: '/cars/{Id}/offline';
};

export type TakeOfflineCarPatchErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type TakeOfflineCarPatchError = TakeOfflineCarPatchErrors[keyof TakeOfflineCarPatchErrors];

export type TakeOfflineCarPatchResponses = {
    /**
     * Accepted
     */
    202: GetCarResponse;
};

export type TakeOfflineCarPatchResponse = TakeOfflineCarPatchResponses[keyof TakeOfflineCarPatchResponses];

export type TakeOfflineCarPutData = {
    body?: TakeOfflineCarRequest;
    path: {
        Id: string;
    };
    query?: never;
    url: '/cars/{Id}/offline';
};

export type TakeOfflineCarPutErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type TakeOfflineCarPutError = TakeOfflineCarPutErrors[keyof TakeOfflineCarPutErrors];

export type TakeOfflineCarPutResponses = {
    /**
     * Accepted
     */
    202: GetCarResponse;
};

export type TakeOfflineCarPutResponse = TakeOfflineCarPutResponses[keyof TakeOfflineCarPutResponses];

export type ChargebeeNotifyWebhookEventData = {
    body?: ChargebeeNotifyWebhookEventRequest;
    path?: never;
    query?: never;
    url: '/webhooks/chargebee';
};

export type ChargebeeNotifyWebhookEventErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ChargebeeNotifyWebhookEventError = ChargebeeNotifyWebhookEventErrors[keyof ChargebeeNotifyWebhookEventErrors];

export type ChargebeeNotifyWebhookEventResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type ChargebeeNotifyWebhookEventResponse = ChargebeeNotifyWebhookEventResponses[keyof ChargebeeNotifyWebhookEventResponses];

export type DeleteOAuth2ClientLogoData = {
    body?: never;
    path: {
        Id: string;
    };
    query?: never;
    url: '/oauth2/clients/{Id}/logo';
};

export type DeleteOAuth2ClientLogoErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type DeleteOAuth2ClientLogoError = DeleteOAuth2ClientLogoErrors[keyof DeleteOAuth2ClientLogoErrors];

export type DeleteOAuth2ClientLogoResponses = {
    /**
     * No Content
     */
    204: GetOAuth2ClientResponse;
};

export type DeleteOAuth2ClientLogoResponse = DeleteOAuth2ClientLogoResponses[keyof DeleteOAuth2ClientLogoResponses];

export type ChangeOAuth2ClientLogoPatchData = {
    body?: {
        files: Array<Blob | File>;
    };
    path: {
        Id: string;
    };
    query?: never;
    url: '/oauth2/clients/{Id}/logo';
};

export type ChangeOAuth2ClientLogoPatchErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ChangeOAuth2ClientLogoPatchError = ChangeOAuth2ClientLogoPatchErrors[keyof ChangeOAuth2ClientLogoPatchErrors];

export type ChangeOAuth2ClientLogoPatchResponses = {
    /**
     * Accepted
     */
    202: GetOAuth2ClientResponse;
};

export type ChangeOAuth2ClientLogoPatchResponse = ChangeOAuth2ClientLogoPatchResponses[keyof ChangeOAuth2ClientLogoPatchResponses];

export type ChangeOAuth2ClientLogoPutData = {
    body?: {
        files: Array<Blob | File>;
    };
    path: {
        Id: string;
    };
    query?: never;
    url: '/oauth2/clients/{Id}/logo';
};

export type ChangeOAuth2ClientLogoPutErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ChangeOAuth2ClientLogoPutError = ChangeOAuth2ClientLogoPutErrors[keyof ChangeOAuth2ClientLogoPutErrors];

export type ChangeOAuth2ClientLogoPutResponses = {
    /**
     * Accepted
     */
    202: GetOAuth2ClientResponse;
};

export type ChangeOAuth2ClientLogoPutResponse = ChangeOAuth2ClientLogoPutResponses[keyof ChangeOAuth2ClientLogoPutResponses];

export type GetOAuth2ClientConsentForCallerData = {
    body?: never;
    path: {
        Id: string;
    };
    query?: never;
    url: '/oauth2/clients/{Id}/consent';
};

export type GetOAuth2ClientConsentForCallerErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type GetOAuth2ClientConsentForCallerError = GetOAuth2ClientConsentForCallerErrors[keyof GetOAuth2ClientConsentForCallerErrors];

export type GetOAuth2ClientConsentForCallerResponses = {
    /**
     * OK
     */
    200: GetOAuth2ClientConsentResponse;
};

export type GetOAuth2ClientConsentForCallerResponse = GetOAuth2ClientConsentForCallerResponses[keyof GetOAuth2ClientConsentForCallerResponses];

export type ConsentOAuth2ClientForCallerData = {
    body?: ConsentOAuth2ClientForCallerRequest;
    path: {
        Id: string;
    };
    query?: never;
    url: '/oauth2/clients/{Id}/consent';
};

export type ConsentOAuth2ClientForCallerErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ConsentOAuth2ClientForCallerError = ConsentOAuth2ClientForCallerErrors[keyof ConsentOAuth2ClientForCallerErrors];

export type ConsentOAuth2ClientForCallerResponses = {
    /**
     * Created: The user has consented to the client
     */
    201: GetOAuth2ClientConsentResponse;
};

export type ConsentOAuth2ClientForCallerResponse = ConsentOAuth2ClientForCallerResponses[keyof ConsentOAuth2ClientForCallerResponses];

export type SearchAllOAuth2ClientsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * List of child resources to embed in the resource
         */
        Embed?: string;
        /**
         * List of fields to include and exclude in the search result
         */
        Filter?: string;
        /**
         * The maximum number of search results to return
         */
        Limit?: number;
        /**
         * The zero-based index of the first search result
         */
        Offset?: number;
        /**
         * List of fields to sort the results on
         */
        Sort?: string;
    };
    url: '/oauth2/clients';
};

export type SearchAllOAuth2ClientsErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type SearchAllOAuth2ClientsError = SearchAllOAuth2ClientsErrors[keyof SearchAllOAuth2ClientsErrors];

export type SearchAllOAuth2ClientsResponses = {
    /**
     * OK
     */
    200: SearchAllOAuth2ClientsResponse;
};

export type SearchAllOAuth2ClientsResponse2 = SearchAllOAuth2ClientsResponses[keyof SearchAllOAuth2ClientsResponses];

export type CreateOAuth2ClientData = {
    body?: CreateOAuth2ClientRequest;
    path?: never;
    query?: never;
    url: '/oauth2/clients';
};

export type CreateOAuth2ClientErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type CreateOAuth2ClientError = CreateOAuth2ClientErrors[keyof CreateOAuth2ClientErrors];

export type CreateOAuth2ClientResponses = {
    /**
     * Created
     */
    201: GetOAuth2ClientResponse;
};

export type CreateOAuth2ClientResponse = CreateOAuth2ClientResponses[keyof CreateOAuth2ClientResponses];

export type DeleteOAuth2ClientData = {
    body?: never;
    path: {
        Id: string;
    };
    query?: never;
    url: '/oauth2/clients/{Id}';
};

export type DeleteOAuth2ClientErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type DeleteOAuth2ClientError = DeleteOAuth2ClientErrors[keyof DeleteOAuth2ClientErrors];

export type DeleteOAuth2ClientResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteOAuth2ClientResponse = DeleteOAuth2ClientResponses[keyof DeleteOAuth2ClientResponses];

export type GetOAuth2ClientData = {
    body?: never;
    path: {
        Id: string;
    };
    query?: never;
    url: '/oauth2/clients/{Id}';
};

export type GetOAuth2ClientErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type GetOAuth2ClientError = GetOAuth2ClientErrors[keyof GetOAuth2ClientErrors];

export type GetOAuth2ClientResponses = {
    /**
     * OK
     */
    200: GetOAuth2ClientWithSecretsResponse;
};

export type GetOAuth2ClientResponse2 = GetOAuth2ClientResponses[keyof GetOAuth2ClientResponses];

export type UpdateOAuth2ClientPatchData = {
    body?: UpdateOAuth2ClientRequest;
    path: {
        Id: string;
    };
    query?: never;
    url: '/oauth2/clients/{Id}';
};

export type UpdateOAuth2ClientPatchErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type UpdateOAuth2ClientPatchError = UpdateOAuth2ClientPatchErrors[keyof UpdateOAuth2ClientPatchErrors];

export type UpdateOAuth2ClientPatchResponses = {
    /**
     * Accepted
     */
    202: GetOAuth2ClientResponse;
};

export type UpdateOAuth2ClientPatchResponse = UpdateOAuth2ClientPatchResponses[keyof UpdateOAuth2ClientPatchResponses];

export type UpdateOAuth2ClientPutData = {
    body?: UpdateOAuth2ClientRequest;
    path: {
        Id: string;
    };
    query?: never;
    url: '/oauth2/clients/{Id}';
};

export type UpdateOAuth2ClientPutErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type UpdateOAuth2ClientPutError = UpdateOAuth2ClientPutErrors[keyof UpdateOAuth2ClientPutErrors];

export type UpdateOAuth2ClientPutResponses = {
    /**
     * Accepted
     */
    202: GetOAuth2ClientResponse;
};

export type UpdateOAuth2ClientPutResponse = UpdateOAuth2ClientPutResponses[keyof UpdateOAuth2ClientPutResponses];

export type GetOAuth2ClientConsentStatusForCallerData = {
    body?: never;
    path: {
        Id: string;
    };
    query: {
        Scope: string;
    };
    url: '/oauth2/clients/{Id}/consent/status';
};

export type GetOAuth2ClientConsentStatusForCallerErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type GetOAuth2ClientConsentStatusForCallerError = GetOAuth2ClientConsentStatusForCallerErrors[keyof GetOAuth2ClientConsentStatusForCallerErrors];

export type GetOAuth2ClientConsentStatusForCallerResponses = {
    /**
     * OK
     */
    200: GetOAuth2ClientConsentStatusResponse;
};

export type GetOAuth2ClientConsentStatusForCallerResponse = GetOAuth2ClientConsentStatusForCallerResponses[keyof GetOAuth2ClientConsentStatusForCallerResponses];

export type RegenerateOAuth2ClientSecretData = {
    body?: RegenerateOAuth2ClientSecretRequest;
    path: {
        Id: string;
    };
    query?: never;
    url: '/oauth2/clients/{Id}/secret';
};

export type RegenerateOAuth2ClientSecretErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type RegenerateOAuth2ClientSecretError = RegenerateOAuth2ClientSecretErrors[keyof RegenerateOAuth2ClientSecretErrors];

export type RegenerateOAuth2ClientSecretResponses = {
    /**
     * Created
     */
    201: RegenerateOAuth2ClientSecretResponse;
};

export type RegenerateOAuth2ClientSecretResponse2 = RegenerateOAuth2ClientSecretResponses[keyof RegenerateOAuth2ClientSecretResponses];

export type RevokeOAuth2ClientConsentForCallerData = {
    body?: never;
    path: {
        Id: string;
    };
    query?: never;
    url: '/oauth2/clients/{Id}/consent/revoke';
};

export type RevokeOAuth2ClientConsentForCallerErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type RevokeOAuth2ClientConsentForCallerError = RevokeOAuth2ClientConsentForCallerErrors[keyof RevokeOAuth2ClientConsentForCallerErrors];

export type RevokeOAuth2ClientConsentForCallerResponses = {
    /**
     * No Content
     */
    204: GetOAuth2ClientConsentResponse;
};

export type RevokeOAuth2ClientConsentForCallerResponse = RevokeOAuth2ClientConsentForCallerResponses[keyof RevokeOAuth2ClientConsentForCallerResponses];

export type AuthenticateCredentialData = {
    body?: AuthenticateCredentialRequest;
    path?: never;
    query?: never;
    url: '/credentials/auth';
};

export type AuthenticateCredentialErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * The user's username or password is invalid
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * When the user has authenticated, but has MFA enabled. The details of the error contains a value of "mfa_required".
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * The user has not yet verified their registration
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * The user's account is suspended or disabled, and cannot be authenticated or used
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type AuthenticateCredentialError = AuthenticateCredentialErrors[keyof AuthenticateCredentialErrors];

export type AuthenticateCredentialResponses = {
    /**
     * Created
     */
    201: AuthenticateResponse;
};

export type AuthenticateCredentialResponse = AuthenticateCredentialResponses[keyof AuthenticateCredentialResponses];

export type CompletePasswordResetData = {
    body?: CompletePasswordResetRequest;
    path: {
        Token: string;
    };
    query?: never;
    url: '/credentials/{Token}/reset/complete';
};

export type CompletePasswordResetErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * The token is invalid or already used
     */
    404: unknown;
    /**
     * The user is not yet registered, or the password reset attempt has expired
     */
    405: unknown;
    /**
     * The password is the same as the last password
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type CompletePasswordResetError = CompletePasswordResetErrors[keyof CompletePasswordResetErrors];

export type CompletePasswordResetResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type CompletePasswordResetResponse = CompletePasswordResetResponses[keyof CompletePasswordResetResponses];

export type GetPersonCredentialRegistrationConfirmationData = {
    body?: never;
    path?: never;
    query: {
        UserId: string;
    };
    url: '/credentials/confirm-registration';
};

export type GetPersonCredentialRegistrationConfirmationErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type GetPersonCredentialRegistrationConfirmationError = GetPersonCredentialRegistrationConfirmationErrors[keyof GetPersonCredentialRegistrationConfirmationErrors];

export type GetPersonCredentialRegistrationConfirmationResponses = {
    /**
     * OK
     */
    200: GetPersonCredentialRegistrationConfirmationResponse;
};

export type GetPersonCredentialRegistrationConfirmationResponse2 = GetPersonCredentialRegistrationConfirmationResponses[keyof GetPersonCredentialRegistrationConfirmationResponses];

export type ConfirmPersonCredentialRegistrationData = {
    body?: ConfirmPersonCredentialRegistrationRequest;
    path?: never;
    query?: never;
    url: '/credentials/confirm-registration';
};

export type ConfirmPersonCredentialRegistrationErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * The user has already confirmed their registration
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ConfirmPersonCredentialRegistrationError = ConfirmPersonCredentialRegistrationErrors[keyof ConfirmPersonCredentialRegistrationErrors];

export type ConfirmPersonCredentialRegistrationResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type ConfirmPersonCredentialRegistrationResponse = ConfirmPersonCredentialRegistrationResponses[keyof ConfirmPersonCredentialRegistrationResponses];

export type ResendPersonCredentialRegistrationConfirmationData = {
    body?: ResendPersonCredentialRegistrationConfirmationRequest;
    path?: never;
    query?: never;
    url: '/credentials/resend-confirmation';
};

export type ResendPersonCredentialRegistrationConfirmationErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * The user has already confirmed their registration
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ResendPersonCredentialRegistrationConfirmationError = ResendPersonCredentialRegistrationConfirmationErrors[keyof ResendPersonCredentialRegistrationConfirmationErrors];

export type ResendPersonCredentialRegistrationConfirmationResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type ResendPersonCredentialRegistrationConfirmationResponse = ResendPersonCredentialRegistrationConfirmationResponses[keyof ResendPersonCredentialRegistrationConfirmationResponses];

export type RegisterPersonCredentialData = {
    body?: RegisterPersonCredentialRequest;
    path?: never;
    query?: never;
    url: '/credentials/register';
};

export type RegisterPersonCredentialErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type RegisterPersonCredentialError = RegisterPersonCredentialErrors[keyof RegisterPersonCredentialErrors];

export type RegisterPersonCredentialResponses = {
    /**
     * Created
     */
    201: RegisterPersonCredentialResponse;
};

export type RegisterPersonCredentialResponse2 = RegisterPersonCredentialResponses[keyof RegisterPersonCredentialResponses];

export type InitiatePasswordResetData = {
    body?: InitiatePasswordResetRequest;
    path?: never;
    query?: never;
    url: '/credentials/reset';
};

export type InitiatePasswordResetErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * The user is not yet registered
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type InitiatePasswordResetError = InitiatePasswordResetErrors[keyof InitiatePasswordResetErrors];

export type InitiatePasswordResetResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type InitiatePasswordResetResponse = InitiatePasswordResetResponses[keyof InitiatePasswordResetResponses];

export type ResendPasswordResetData = {
    body?: ResendPasswordResetRequest;
    path: {
        Token: string;
    };
    query?: never;
    url: '/credentials/{Token}/reset/resend';
};

export type ResendPasswordResetErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * The token is invalid or already used
     */
    404: unknown;
    /**
     * The user is not yet registered
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ResendPasswordResetError = ResendPasswordResetErrors[keyof ResendPasswordResetErrors];

export type ResendPasswordResetResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type ResendPasswordResetResponse = ResendPasswordResetResponses[keyof ResendPasswordResetResponses];

export type VerifyPasswordResetData = {
    body?: never;
    path: {
        Token: string;
    };
    query?: never;
    url: '/credentials/{Token}/reset/verify';
};

export type VerifyPasswordResetErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * The token is invalid or already used
     */
    404: unknown;
    /**
     * The password reset attempt has expired
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type VerifyPasswordResetError = VerifyPasswordResetErrors[keyof VerifyPasswordResetErrors];

export type VerifyPasswordResetResponses = {
    /**
     * OK
     */
    200: EmptyResponse;
};

export type VerifyPasswordResetResponse = VerifyPasswordResetResponses[keyof VerifyPasswordResetResponses];

export type DrainAllEventNotificationsData = {
    body?: DrainAllEventNotificationsRequest;
    path?: never;
    query?: never;
    url: '/event_notifications/drain';
};

export type DrainAllEventNotificationsErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type DrainAllEventNotificationsError = DrainAllEventNotificationsErrors[keyof DrainAllEventNotificationsErrors];

export type DrainAllEventNotificationsResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type DrainAllEventNotificationsResponse = DrainAllEventNotificationsResponses[keyof DrainAllEventNotificationsResponses];

export type SearchAllEventNotificationsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * List of child resources to embed in the resource
         */
        Embed?: string;
        /**
         * List of fields to include and exclude in the search result
         */
        Filter?: string;
        /**
         * The maximum number of search results to return
         */
        Limit?: number;
        /**
         * The zero-based index of the first search result
         */
        Offset?: number;
        /**
         * List of fields to sort the results on
         */
        Sort?: string;
    };
    url: '/event_notifications';
};

export type SearchAllEventNotificationsErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type SearchAllEventNotificationsError = SearchAllEventNotificationsErrors[keyof SearchAllEventNotificationsErrors];

export type SearchAllEventNotificationsResponses = {
    /**
     * OK
     */
    200: SearchAllEventNotificationsResponse;
};

export type SearchAllEventNotificationsResponse2 = SearchAllEventNotificationsResponses[keyof SearchAllEventNotificationsResponses];

export type NotifyDomainEventData = {
    body?: NotifyDomainEventRequest;
    path?: never;
    query?: never;
    url: '/event_notifications';
};

export type NotifyDomainEventErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type NotifyDomainEventError = NotifyDomainEventErrors[keyof NotifyDomainEventErrors];

export type NotifyDomainEventResponses = {
    /**
     * Created
     */
    201: DeliverMessageResponse;
};

export type NotifyDomainEventResponse = NotifyDomainEventResponses[keyof NotifyDomainEventResponses];

export type ConfirmEmailDeliveredData = {
    body?: ConfirmEmailDeliveredRequest;
    path?: never;
    query?: never;
    url: '/emails/delivered';
};

export type ConfirmEmailDeliveredErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ConfirmEmailDeliveredError = ConfirmEmailDeliveredErrors[keyof ConfirmEmailDeliveredErrors];

export type ConfirmEmailDeliveredResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type ConfirmEmailDeliveredResponse = ConfirmEmailDeliveredResponses[keyof ConfirmEmailDeliveredResponses];

export type ConfirmEmailDeliveryFailedData = {
    body?: ConfirmEmailDeliveryFailedRequest;
    path?: never;
    query?: never;
    url: '/emails/failed';
};

export type ConfirmEmailDeliveryFailedErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ConfirmEmailDeliveryFailedError = ConfirmEmailDeliveryFailedErrors[keyof ConfirmEmailDeliveryFailedErrors];

export type ConfirmEmailDeliveryFailedResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type ConfirmEmailDeliveryFailedResponse = ConfirmEmailDeliveryFailedResponses[keyof ConfirmEmailDeliveryFailedResponses];

export type DrainAllEmailsData = {
    body?: DrainAllEmailsRequest;
    path?: never;
    query?: never;
    url: '/emails/drain';
};

export type DrainAllEmailsErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type DrainAllEmailsError = DrainAllEmailsErrors[keyof DrainAllEmailsErrors];

export type DrainAllEmailsResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type DrainAllEmailsResponse = DrainAllEmailsResponses[keyof DrainAllEmailsResponses];

export type SearchAllEmailDeliveriesData = {
    body?: never;
    path?: never;
    query?: {
        OrganizationId?: string;
        SinceUtc?: string;
        Tags?: string;
        /**
         * List of child resources to embed in the resource
         */
        Embed?: string;
        /**
         * List of fields to include and exclude in the search result
         */
        Filter?: string;
        /**
         * The maximum number of search results to return
         */
        Limit?: number;
        /**
         * The zero-based index of the first search result
         */
        Offset?: number;
        /**
         * List of fields to sort the results on
         */
        Sort?: string;
    };
    url: '/emails';
};

export type SearchAllEmailDeliveriesErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type SearchAllEmailDeliveriesError = SearchAllEmailDeliveriesErrors[keyof SearchAllEmailDeliveriesErrors];

export type SearchAllEmailDeliveriesResponses = {
    /**
     * OK
     */
    200: SearchAllEmailDeliveriesResponse;
};

export type SearchAllEmailDeliveriesResponse2 = SearchAllEmailDeliveriesResponses[keyof SearchAllEmailDeliveriesResponses];

export type SendEmailData = {
    body?: SendEmailRequest;
    path?: never;
    query?: never;
    url: '/emails/send';
};

export type SendEmailErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type SendEmailError = SendEmailErrors[keyof SendEmailErrors];

export type SendEmailResponses = {
    /**
     * Created
     */
    201: DeliverMessageResponse;
};

export type SendEmailResponse = SendEmailResponses[keyof SendEmailResponses];

export type UnassignPlatformRolesPatchData = {
    body?: UnassignPlatformRolesRequest;
    path: {
        Id: string;
    };
    query?: never;
    url: '/users/{Id}/roles';
};

export type UnassignPlatformRolesPatchErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type UnassignPlatformRolesPatchError = UnassignPlatformRolesPatchErrors[keyof UnassignPlatformRolesPatchErrors];

export type UnassignPlatformRolesPatchResponses = {
    /**
     * Accepted
     */
    202: UpdateUserResponse;
};

export type UnassignPlatformRolesPatchResponse = UnassignPlatformRolesPatchResponses[keyof UnassignPlatformRolesPatchResponses];

export type AssignPlatformRolesData = {
    body?: AssignPlatformRolesRequest;
    path: {
        Id: string;
    };
    query?: never;
    url: '/users/{Id}/roles';
};

export type AssignPlatformRolesErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type AssignPlatformRolesError = AssignPlatformRolesErrors[keyof AssignPlatformRolesErrors];

export type AssignPlatformRolesResponses = {
    /**
     * Created
     */
    201: UpdateUserResponse;
};

export type AssignPlatformRolesResponse = AssignPlatformRolesResponses[keyof AssignPlatformRolesResponses];

export type UnassignPlatformRolesPutData = {
    body?: UnassignPlatformRolesRequest;
    path: {
        Id: string;
    };
    query?: never;
    url: '/users/{Id}/roles';
};

export type UnassignPlatformRolesPutErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type UnassignPlatformRolesPutError = UnassignPlatformRolesPutErrors[keyof UnassignPlatformRolesPutErrors];

export type UnassignPlatformRolesPutResponses = {
    /**
     * Accepted
     */
    202: UpdateUserResponse;
};

export type UnassignPlatformRolesPutResponse = UnassignPlatformRolesPutResponses[keyof UnassignPlatformRolesPutResponses];

export type NotifyFakeBillingProviderWebHookEventData = {
    body?: NotifyFakeBillingProviderWebHookEventRequest;
    path?: never;
    query?: never;
    url: '/webhooks/providers/billing/fake';
};

export type NotifyFakeBillingProviderWebHookEventErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type NotifyFakeBillingProviderWebHookEventError = NotifyFakeBillingProviderWebHookEventErrors[keyof NotifyFakeBillingProviderWebHookEventErrors];

export type NotifyFakeBillingProviderWebHookEventResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type NotifyFakeBillingProviderWebHookEventResponse = NotifyFakeBillingProviderWebHookEventResponses[keyof NotifyFakeBillingProviderWebHookEventResponses];

export type GetFeatureFlagData = {
    body?: never;
    path: {
        Name: string;
        UserId: string;
    };
    query?: {
        TenantId?: string;
    };
    url: '/flags/{UserId}/{Name}';
};

export type GetFeatureFlagErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type GetFeatureFlagError = GetFeatureFlagErrors[keyof GetFeatureFlagErrors];

export type GetFeatureFlagResponses = {
    /**
     * OK
     */
    200: GetFeatureFlagResponse;
};

export type GetFeatureFlagResponse2 = GetFeatureFlagResponses[keyof GetFeatureFlagResponses];

export type GetAllFeatureFlagsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/flags';
};

export type GetAllFeatureFlagsErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type GetAllFeatureFlagsError = GetAllFeatureFlagsErrors[keyof GetAllFeatureFlagsErrors];

export type GetAllFeatureFlagsResponses = {
    /**
     * OK
     */
    200: GetAllFeatureFlagsResponse;
};

export type GetAllFeatureFlagsResponse2 = GetAllFeatureFlagsResponses[keyof GetAllFeatureFlagsResponses];

export type GetFeatureFlagForCallerData = {
    body?: never;
    path: {
        Name: string;
    };
    query?: never;
    url: '/flags/{Name}';
};

export type GetFeatureFlagForCallerErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type GetFeatureFlagForCallerError = GetFeatureFlagForCallerErrors[keyof GetFeatureFlagForCallerErrors];

export type GetFeatureFlagForCallerResponses = {
    /**
     * OK
     */
    200: GetFeatureFlagResponse;
};

export type GetFeatureFlagForCallerResponse = GetFeatureFlagForCallerResponses[keyof GetFeatureFlagForCallerResponses];

export type HealthCheckData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/health';
};

export type HealthCheckErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type HealthCheckError = HealthCheckErrors[keyof HealthCheckErrors];

export type HealthCheckResponses = {
    /**
     * OK
     */
    200: HealthCheckResponse;
};

export type HealthCheckResponse2 = HealthCheckResponses[keyof HealthCheckResponses];

export type GetIdentityForCallerData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/users/me';
};

export type GetIdentityForCallerErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type GetIdentityForCallerError = GetIdentityForCallerErrors[keyof GetIdentityForCallerErrors];

export type GetIdentityForCallerResponses = {
    /**
     * OK
     */
    200: GetIdentityResponse;
};

export type GetIdentityForCallerResponse = GetIdentityForCallerResponses[keyof GetIdentityForCallerResponses];

export type DeleteImageData = {
    body?: never;
    path: {
        Id: string;
    };
    query?: never;
    url: '/images/{Id}';
};

export type DeleteImageErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type DeleteImageError = DeleteImageErrors[keyof DeleteImageErrors];

export type DeleteImageResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteImageResponse = DeleteImageResponses[keyof DeleteImageResponses];

export type GetImageData = {
    body?: never;
    path: {
        Id: string;
    };
    query?: never;
    url: '/images/{Id}';
};

export type GetImageErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type GetImageError = GetImageErrors[keyof GetImageErrors];

export type GetImageResponses = {
    /**
     * OK
     */
    200: GetImageResponse;
};

export type GetImageResponse2 = GetImageResponses[keyof GetImageResponses];

export type UpdateImagePatchData = {
    body?: UpdateImageRequest;
    path: {
        Id: string;
    };
    query?: never;
    url: '/images/{Id}';
};

export type UpdateImagePatchErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type UpdateImagePatchError = UpdateImagePatchErrors[keyof UpdateImagePatchErrors];

export type UpdateImagePatchResponses = {
    /**
     * Accepted
     */
    202: UpdateImageResponse;
};

export type UpdateImagePatchResponse = UpdateImagePatchResponses[keyof UpdateImagePatchResponses];

export type UpdateImagePutData = {
    body?: UpdateImageRequest;
    path: {
        Id: string;
    };
    query?: never;
    url: '/images/{Id}';
};

export type UpdateImagePutErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type UpdateImagePutError = UpdateImagePutErrors[keyof UpdateImagePutErrors];

export type UpdateImagePutResponses = {
    /**
     * Accepted
     */
    202: UpdateImageResponse;
};

export type UpdateImagePutResponse = UpdateImagePutResponses[keyof UpdateImagePutResponses];

export type DownloadImageData = {
    body?: never;
    path: {
        Id: string;
    };
    query?: never;
    url: '/images/{Id}/download';
};

export type DownloadImageErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type DownloadImageError = DownloadImageErrors[keyof DownloadImageErrors];

export type DownloadImageResponses = {
    /**
     * OK
     */
    200: Blob | File;
};

export type DownloadImageResponse = DownloadImageResponses[keyof DownloadImageResponses];

export type UploadImageData = {
    body?: {
        files: Array<Blob | File>;
        description?: string;
    };
    path?: never;
    query?: never;
    url: '/images';
};

export type UploadImageErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type UploadImageError = UploadImageErrors[keyof UploadImageErrors];

export type UploadImageResponses = {
    /**
     * Created
     */
    201: UploadImageResponse;
};

export type UploadImageResponse2 = UploadImageResponses[keyof UploadImageResponses];

export type InviteGuestData = {
    body?: InviteGuestRequest;
    path?: never;
    query?: never;
    url: '/invitations';
};

export type InviteGuestErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type InviteGuestError = InviteGuestErrors[keyof InviteGuestErrors];

export type InviteGuestResponses = {
    /**
     * Created
     */
    201: InviteGuestResponse;
};

export type InviteGuestResponse2 = InviteGuestResponses[keyof InviteGuestResponses];

export type ResendGuestInvitationData = {
    body?: ResendGuestInvitationRequest;
    path: {
        Token: string;
    };
    query?: never;
    url: '/invitations/{Token}/resend';
};

export type ResendGuestInvitationErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ResendGuestInvitationError = ResendGuestInvitationErrors[keyof ResendGuestInvitationErrors];

export type ResendGuestInvitationResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type ResendGuestInvitationResponse = ResendGuestInvitationResponses[keyof ResendGuestInvitationResponses];

export type VerifyGuestInvitationData = {
    body?: never;
    path: {
        Token: string;
    };
    query?: never;
    url: '/invitations/{Token}/verify';
};

export type VerifyGuestInvitationErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type VerifyGuestInvitationError = VerifyGuestInvitationErrors[keyof VerifyGuestInvitationErrors];

export type VerifyGuestInvitationResponses = {
    /**
     * OK
     */
    200: VerifyGuestInvitationResponse;
};

export type VerifyGuestInvitationResponse2 = VerifyGuestInvitationResponses[keyof VerifyGuestInvitationResponses];

export type RegisterMachineData = {
    body?: RegisterMachineRequest;
    path?: never;
    query?: never;
    url: '/machines/register';
};

export type RegisterMachineErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type RegisterMachineError = RegisterMachineErrors[keyof RegisterMachineErrors];

export type RegisterMachineResponses = {
    /**
     * Created
     */
    201: RegisterMachineResponse;
};

export type RegisterMachineResponse2 = RegisterMachineResponses[keyof RegisterMachineResponses];

export type MailgunNotifyWebhookEventData = {
    body?: MailgunNotifyWebhookEventRequest;
    path?: never;
    query?: never;
    url: '/webhooks/mailgun';
};

export type MailgunNotifyWebhookEventErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type MailgunNotifyWebhookEventError = MailgunNotifyWebhookEventErrors[keyof MailgunNotifyWebhookEventErrors];

export type MailgunNotifyWebhookEventResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type MailgunNotifyWebhookEventResponse = MailgunNotifyWebhookEventResponses[keyof MailgunNotifyWebhookEventResponses];

export type ChangeDefaultOrganizationPatchData = {
    body?: ChangeDefaultOrganizationRequest;
    path?: never;
    query?: never;
    url: '/memberships/me/default';
};

export type ChangeDefaultOrganizationPatchErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ChangeDefaultOrganizationPatchError = ChangeDefaultOrganizationPatchErrors[keyof ChangeDefaultOrganizationPatchErrors];

export type ChangeDefaultOrganizationPatchResponses = {
    /**
     * Accepted
     */
    202: UpdateUserResponse;
};

export type ChangeDefaultOrganizationPatchResponse = ChangeDefaultOrganizationPatchResponses[keyof ChangeDefaultOrganizationPatchResponses];

export type ChangeDefaultOrganizationPutData = {
    body?: ChangeDefaultOrganizationRequest;
    path?: never;
    query?: never;
    url: '/memberships/me/default';
};

export type ChangeDefaultOrganizationPutErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ChangeDefaultOrganizationPutError = ChangeDefaultOrganizationPutErrors[keyof ChangeDefaultOrganizationPutErrors];

export type ChangeDefaultOrganizationPutResponses = {
    /**
     * Accepted
     */
    202: UpdateUserResponse;
};

export type ChangeDefaultOrganizationPutResponse = ChangeDefaultOrganizationPutResponses[keyof ChangeDefaultOrganizationPutResponses];

export type ListMembershipsForCallerData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * List of child resources to embed in the resource
         */
        Embed?: string;
        /**
         * List of fields to include and exclude in the search result
         */
        Filter?: string;
        /**
         * The maximum number of search results to return
         */
        Limit?: number;
        /**
         * The zero-based index of the first search result
         */
        Offset?: number;
        /**
         * List of fields to sort the results on
         */
        Sort?: string;
    };
    url: '/memberships/me';
};

export type ListMembershipsForCallerErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ListMembershipsForCallerError = ListMembershipsForCallerErrors[keyof ListMembershipsForCallerErrors];

export type ListMembershipsForCallerResponses = {
    /**
     * OK
     */
    200: ListMembershipsForCallerResponse;
};

export type ListMembershipsForCallerResponse2 = ListMembershipsForCallerResponses[keyof ListMembershipsForCallerResponses];

export type ListCredentialMfaAuthenticatorsForCallerData = {
    body?: never;
    path?: never;
    query?: {
        MfaToken?: string;
    };
    url: '/credentials/mfa/authenticators';
};

export type ListCredentialMfaAuthenticatorsForCallerErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ListCredentialMfaAuthenticatorsForCallerError = ListCredentialMfaAuthenticatorsForCallerErrors[keyof ListCredentialMfaAuthenticatorsForCallerErrors];

export type ListCredentialMfaAuthenticatorsForCallerResponses = {
    /**
     * OK
     */
    200: ListCredentialMfaAuthenticatorsForCallerResponse;
};

export type ListCredentialMfaAuthenticatorsForCallerResponse2 = ListCredentialMfaAuthenticatorsForCallerResponses[keyof ListCredentialMfaAuthenticatorsForCallerResponses];

export type AssociateCredentialMfaAuthenticatorForCallerData = {
    body?: AssociateCredentialMfaAuthenticatorForCallerRequest;
    path?: never;
    query?: never;
    url: '/credentials/mfa/authenticators';
};

export type AssociateCredentialMfaAuthenticatorForCallerErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * The user has already associated at least one other authenticator, or this authenticator is already associated. You must make a challenge using an existing association
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type AssociateCredentialMfaAuthenticatorForCallerError = AssociateCredentialMfaAuthenticatorForCallerErrors[keyof AssociateCredentialMfaAuthenticatorForCallerErrors];

export type AssociateCredentialMfaAuthenticatorForCallerResponses = {
    /**
     * Created
     */
    201: AssociateCredentialMfaAuthenticatorForCallerResponse;
};

export type AssociateCredentialMfaAuthenticatorForCallerResponse2 = AssociateCredentialMfaAuthenticatorForCallerResponses[keyof AssociateCredentialMfaAuthenticatorForCallerResponses];

export type ChallengeCredentialMfaAuthenticatorForCallerPatchData = {
    body?: ChallengeCredentialMfaAuthenticatorForCallerRequest;
    path: {
        AuthenticatorId: string;
    };
    query?: never;
    url: '/credentials/mfa/authenticators/{AuthenticatorId}/challenge';
};

export type ChallengeCredentialMfaAuthenticatorForCallerPatchErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ChallengeCredentialMfaAuthenticatorForCallerPatchError = ChallengeCredentialMfaAuthenticatorForCallerPatchErrors[keyof ChallengeCredentialMfaAuthenticatorForCallerPatchErrors];

export type ChallengeCredentialMfaAuthenticatorForCallerPatchResponses = {
    /**
     * Accepted
     */
    202: ChallengeCredentialMfaAuthenticatorForCallerResponse;
};

export type ChallengeCredentialMfaAuthenticatorForCallerPatchResponse = ChallengeCredentialMfaAuthenticatorForCallerPatchResponses[keyof ChallengeCredentialMfaAuthenticatorForCallerPatchResponses];

export type ChallengeCredentialMfaAuthenticatorForCallerPutData = {
    body?: ChallengeCredentialMfaAuthenticatorForCallerRequest;
    path: {
        AuthenticatorId: string;
    };
    query?: never;
    url: '/credentials/mfa/authenticators/{AuthenticatorId}/challenge';
};

export type ChallengeCredentialMfaAuthenticatorForCallerPutErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ChallengeCredentialMfaAuthenticatorForCallerPutError = ChallengeCredentialMfaAuthenticatorForCallerPutErrors[keyof ChallengeCredentialMfaAuthenticatorForCallerPutErrors];

export type ChallengeCredentialMfaAuthenticatorForCallerPutResponses = {
    /**
     * Accepted
     */
    202: ChallengeCredentialMfaAuthenticatorForCallerResponse;
};

export type ChallengeCredentialMfaAuthenticatorForCallerPutResponse = ChallengeCredentialMfaAuthenticatorForCallerPutResponses[keyof ChallengeCredentialMfaAuthenticatorForCallerPutResponses];

export type ChangeCredentialMfaForCallerPatchData = {
    body?: ChangeCredentialMfaForCallerRequest;
    path?: never;
    query?: never;
    url: '/credentials/mfa';
};

export type ChangeCredentialMfaForCallerPatchErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ChangeCredentialMfaForCallerPatchError = ChangeCredentialMfaForCallerPatchErrors[keyof ChangeCredentialMfaForCallerPatchErrors];

export type ChangeCredentialMfaForCallerPatchResponses = {
    /**
     * Accepted
     */
    202: ChangeCredentialMfaResponse;
};

export type ChangeCredentialMfaForCallerPatchResponse = ChangeCredentialMfaForCallerPatchResponses[keyof ChangeCredentialMfaForCallerPatchResponses];

export type ChangeCredentialMfaForCallerPutData = {
    body?: ChangeCredentialMfaForCallerRequest;
    path?: never;
    query?: never;
    url: '/credentials/mfa';
};

export type ChangeCredentialMfaForCallerPutErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ChangeCredentialMfaForCallerPutError = ChangeCredentialMfaForCallerPutErrors[keyof ChangeCredentialMfaForCallerPutErrors];

export type ChangeCredentialMfaForCallerPutResponses = {
    /**
     * Accepted
     */
    202: ChangeCredentialMfaResponse;
};

export type ChangeCredentialMfaForCallerPutResponse = ChangeCredentialMfaForCallerPutResponses[keyof ChangeCredentialMfaForCallerPutResponses];

export type ConfirmCredentialMfaAuthenticatorForCallerPatchData = {
    body?: ConfirmCredentialMfaAuthenticatorForCallerRequest;
    path: {
        AuthenticatorType: string;
    };
    query?: never;
    url: '/credentials/mfa/authenticators/{AuthenticatorType}/confirm';
};

export type ConfirmCredentialMfaAuthenticatorForCallerPatchErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * The user has not yet associated an authenticator of the specified type
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ConfirmCredentialMfaAuthenticatorForCallerPatchError = ConfirmCredentialMfaAuthenticatorForCallerPatchErrors[keyof ConfirmCredentialMfaAuthenticatorForCallerPatchErrors];

export type ConfirmCredentialMfaAuthenticatorForCallerPatchResponses = {
    /**
     * Accepted
     */
    202: ConfirmCredentialMfaAuthenticatorForCallerResponse;
};

export type ConfirmCredentialMfaAuthenticatorForCallerPatchResponse = ConfirmCredentialMfaAuthenticatorForCallerPatchResponses[keyof ConfirmCredentialMfaAuthenticatorForCallerPatchResponses];

export type ConfirmCredentialMfaAuthenticatorForCallerPutData = {
    body?: ConfirmCredentialMfaAuthenticatorForCallerRequest;
    path: {
        AuthenticatorType: string;
    };
    query?: never;
    url: '/credentials/mfa/authenticators/{AuthenticatorType}/confirm';
};

export type ConfirmCredentialMfaAuthenticatorForCallerPutErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * The user has not yet associated an authenticator of the specified type
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ConfirmCredentialMfaAuthenticatorForCallerPutError = ConfirmCredentialMfaAuthenticatorForCallerPutErrors[keyof ConfirmCredentialMfaAuthenticatorForCallerPutErrors];

export type ConfirmCredentialMfaAuthenticatorForCallerPutResponses = {
    /**
     * Accepted
     */
    202: ConfirmCredentialMfaAuthenticatorForCallerResponse;
};

export type ConfirmCredentialMfaAuthenticatorForCallerPutResponse = ConfirmCredentialMfaAuthenticatorForCallerPutResponses[keyof ConfirmCredentialMfaAuthenticatorForCallerPutResponses];

export type DisassociateCredentialMfaAuthenticatorForCallerData = {
    body?: never;
    path: {
        Id: string;
    };
    query?: never;
    url: '/credentials/mfa/authenticators/{Id}';
};

export type DisassociateCredentialMfaAuthenticatorForCallerErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type DisassociateCredentialMfaAuthenticatorForCallerError = DisassociateCredentialMfaAuthenticatorForCallerErrors[keyof DisassociateCredentialMfaAuthenticatorForCallerErrors];

export type DisassociateCredentialMfaAuthenticatorForCallerResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DisassociateCredentialMfaAuthenticatorForCallerResponse = DisassociateCredentialMfaAuthenticatorForCallerResponses[keyof DisassociateCredentialMfaAuthenticatorForCallerResponses];

export type ResetCredentialMfaPatchData = {
    body?: ResetCredentialMfaRequest;
    path?: never;
    query?: never;
    url: '/credentials/mfa/reset';
};

export type ResetCredentialMfaPatchErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ResetCredentialMfaPatchError = ResetCredentialMfaPatchErrors[keyof ResetCredentialMfaPatchErrors];

export type ResetCredentialMfaPatchResponses = {
    /**
     * Accepted
     */
    202: ChangeCredentialMfaResponse;
};

export type ResetCredentialMfaPatchResponse = ResetCredentialMfaPatchResponses[keyof ResetCredentialMfaPatchResponses];

export type ResetCredentialMfaPutData = {
    body?: ResetCredentialMfaRequest;
    path?: never;
    query?: never;
    url: '/credentials/mfa/reset';
};

export type ResetCredentialMfaPutErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ResetCredentialMfaPutError = ResetCredentialMfaPutErrors[keyof ResetCredentialMfaPutErrors];

export type ResetCredentialMfaPutResponses = {
    /**
     * Accepted
     */
    202: ChangeCredentialMfaResponse;
};

export type ResetCredentialMfaPutResponse = ResetCredentialMfaPutResponses[keyof ResetCredentialMfaPutResponses];

export type VerifyCredentialMfaAuthenticatorForCallerPatchData = {
    body?: VerifyCredentialMfaAuthenticatorForCallerRequest;
    path: {
        AuthenticatorType: string;
    };
    query?: never;
    url: '/credentials/mfa/authenticators/{AuthenticatorType}/verify';
};

export type VerifyCredentialMfaAuthenticatorForCallerPatchErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type VerifyCredentialMfaAuthenticatorForCallerPatchError = VerifyCredentialMfaAuthenticatorForCallerPatchErrors[keyof VerifyCredentialMfaAuthenticatorForCallerPatchErrors];

export type VerifyCredentialMfaAuthenticatorForCallerPatchResponses = {
    /**
     * Accepted
     */
    202: AuthenticateResponse;
};

export type VerifyCredentialMfaAuthenticatorForCallerPatchResponse = VerifyCredentialMfaAuthenticatorForCallerPatchResponses[keyof VerifyCredentialMfaAuthenticatorForCallerPatchResponses];

export type VerifyCredentialMfaAuthenticatorForCallerPutData = {
    body?: VerifyCredentialMfaAuthenticatorForCallerRequest;
    path: {
        AuthenticatorType: string;
    };
    query?: never;
    url: '/credentials/mfa/authenticators/{AuthenticatorType}/verify';
};

export type VerifyCredentialMfaAuthenticatorForCallerPutErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type VerifyCredentialMfaAuthenticatorForCallerPutError = VerifyCredentialMfaAuthenticatorForCallerPutErrors[keyof VerifyCredentialMfaAuthenticatorForCallerPutErrors];

export type VerifyCredentialMfaAuthenticatorForCallerPutResponses = {
    /**
     * Accepted
     */
    202: AuthenticateResponse;
};

export type VerifyCredentialMfaAuthenticatorForCallerPutResponse = VerifyCredentialMfaAuthenticatorForCallerPutResponses[keyof VerifyCredentialMfaAuthenticatorForCallerPutResponses];

export type AuthorizeOAuth2Data = {
    body?: {
        clientId: string;
        codeChallenge?: string;
        codeChallengeMethod?: unknown;
        nonce?: string;
        redirectUri: string;
        responseType: unknown;
        scope: string;
        state?: string;
    };
    path?: never;
    query?: never;
    url: '/oauth2/authorize';
};

export type AuthorizeOAuth2Errors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type AuthorizeOAuth2Error = AuthorizeOAuth2Errors[keyof AuthorizeOAuth2Errors];

export type AuthorizeOAuth2Responses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type AuthorizeOAuth2Response = AuthorizeOAuth2Responses[keyof AuthorizeOAuth2Responses];

export type ExchangeOAuth2ForTokensData = {
    body?: {
        clientId: string;
        clientSecret?: string;
        code: string;
        codeVerifier?: string;
        grantType: unknown;
        redirectUri: string;
        refreshToken?: string;
        scope?: string;
    };
    path?: never;
    query?: never;
    url: '/oauth2/token';
};

export type ExchangeOAuth2ForTokensErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * The user is not known, or not registered
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * The user's account is suspended or disabled, and cannot be used
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ExchangeOAuth2ForTokensError = ExchangeOAuth2ForTokensErrors[keyof ExchangeOAuth2ForTokensErrors];

export type ExchangeOAuth2ForTokensResponses = {
    /**
     * Created
     */
    201: ExchangeOAuth2ForTokensResponse;
};

export type ExchangeOAuth2ForTokensResponse2 = ExchangeOAuth2ForTokensResponses[keyof ExchangeOAuth2ForTokensResponses];

export type GetUserInfoForCallerData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/oauth2/userinfo';
};

export type GetUserInfoForCallerErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * The token was not authorized using Open ID Connect, or the user is not consented to the client, or the user is unknown or not registered
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * The user's account is suspended or disabled, and cannot be used
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type GetUserInfoForCallerError = GetUserInfoForCallerErrors[keyof GetUserInfoForCallerErrors];

export type GetUserInfoForCallerResponses = {
    /**
     * OK
     */
    200: GetUserInfoForCallerResponse;
};

export type GetUserInfoForCallerResponse2 = GetUserInfoForCallerResponses[keyof GetUserInfoForCallerResponses];

export type GetDiscoveryDocumentData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/.well-known/openid-configuration';
};

export type GetDiscoveryDocumentErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type GetDiscoveryDocumentError = GetDiscoveryDocumentErrors[keyof GetDiscoveryDocumentErrors];

export type GetDiscoveryDocumentResponses = {
    /**
     * OK
     */
    200: GetDiscoveryDocumentResponse;
};

export type GetDiscoveryDocumentResponse2 = GetDiscoveryDocumentResponses[keyof GetDiscoveryDocumentResponses];

export type GetJsonWebKeySetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/.well-known/jwks.json';
};

export type GetJsonWebKeySetErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type GetJsonWebKeySetError = GetJsonWebKeySetErrors[keyof GetJsonWebKeySetErrors];

export type GetJsonWebKeySetResponses = {
    /**
     * OK
     */
    200: GetJsonWebKeySetResponse;
};

export type GetJsonWebKeySetResponse2 = GetJsonWebKeySetResponses[keyof GetJsonWebKeySetResponses];

export type AssignRolesToOrganizationPatchData = {
    body?: AssignRolesToOrganizationRequest;
    path: {
        Id: string;
    };
    query?: never;
    url: '/organizations/{Id}/roles/assign';
};

export type AssignRolesToOrganizationPatchErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * The assigner is not an owner of the organization
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type AssignRolesToOrganizationPatchError = AssignRolesToOrganizationPatchErrors[keyof AssignRolesToOrganizationPatchErrors];

export type AssignRolesToOrganizationPatchResponses = {
    /**
     * Accepted
     */
    202: GetOrganizationResponse;
};

export type AssignRolesToOrganizationPatchResponse = AssignRolesToOrganizationPatchResponses[keyof AssignRolesToOrganizationPatchResponses];

export type AssignRolesToOrganizationPutData = {
    body?: AssignRolesToOrganizationRequest;
    path: {
        Id: string;
    };
    query?: never;
    url: '/organizations/{Id}/roles/assign';
};

export type AssignRolesToOrganizationPutErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * The assigner is not an owner of the organization
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type AssignRolesToOrganizationPutError = AssignRolesToOrganizationPutErrors[keyof AssignRolesToOrganizationPutErrors];

export type AssignRolesToOrganizationPutResponses = {
    /**
     * Accepted
     */
    202: GetOrganizationResponse;
};

export type AssignRolesToOrganizationPutResponse = AssignRolesToOrganizationPutResponses[keyof AssignRolesToOrganizationPutResponses];

export type DeleteOrganizationAvatarData = {
    body?: never;
    path: {
        Id: string;
    };
    query?: never;
    url: '/organizations/{Id}/avatar';
};

export type DeleteOrganizationAvatarErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type DeleteOrganizationAvatarError = DeleteOrganizationAvatarErrors[keyof DeleteOrganizationAvatarErrors];

export type DeleteOrganizationAvatarResponses = {
    /**
     * No Content
     */
    204: GetOrganizationResponse;
};

export type DeleteOrganizationAvatarResponse = DeleteOrganizationAvatarResponses[keyof DeleteOrganizationAvatarResponses];

export type ChangeOrganizationAvatarPatchData = {
    body?: {
        files: Array<Blob | File>;
    };
    path: {
        Id: string;
    };
    query?: never;
    url: '/organizations/{Id}/avatar';
};

export type ChangeOrganizationAvatarPatchErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ChangeOrganizationAvatarPatchError = ChangeOrganizationAvatarPatchErrors[keyof ChangeOrganizationAvatarPatchErrors];

export type ChangeOrganizationAvatarPatchResponses = {
    /**
     * Accepted
     */
    202: GetOrganizationResponse;
};

export type ChangeOrganizationAvatarPatchResponse = ChangeOrganizationAvatarPatchResponses[keyof ChangeOrganizationAvatarPatchResponses];

export type ChangeOrganizationAvatarPutData = {
    body?: {
        files: Array<Blob | File>;
    };
    path: {
        Id: string;
    };
    query?: never;
    url: '/organizations/{Id}/avatar';
};

export type ChangeOrganizationAvatarPutErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ChangeOrganizationAvatarPutError = ChangeOrganizationAvatarPutErrors[keyof ChangeOrganizationAvatarPutErrors];

export type ChangeOrganizationAvatarPutResponses = {
    /**
     * Accepted
     */
    202: GetOrganizationResponse;
};

export type ChangeOrganizationAvatarPutResponse = ChangeOrganizationAvatarPutResponses[keyof ChangeOrganizationAvatarPutResponses];

export type DeleteOrganizationData = {
    body?: never;
    path: {
        Id: string;
    };
    query?: never;
    url: '/organizations/{Id}';
};

export type DeleteOrganizationErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type DeleteOrganizationError = DeleteOrganizationErrors[keyof DeleteOrganizationErrors];

export type DeleteOrganizationResponses = {
    /**
     * No Content
     */
    204: void;
};

export type DeleteOrganizationResponse = DeleteOrganizationResponses[keyof DeleteOrganizationResponses];

export type GetOrganizationData = {
    body?: never;
    path: {
        Id: string;
    };
    query?: never;
    url: '/organizations/{Id}';
};

export type GetOrganizationErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type GetOrganizationError = GetOrganizationErrors[keyof GetOrganizationErrors];

export type GetOrganizationResponses = {
    /**
     * OK
     */
    200: GetOrganizationResponse;
};

export type GetOrganizationResponse2 = GetOrganizationResponses[keyof GetOrganizationResponses];

export type ChangeOrganizationPatchData = {
    body?: ChangeOrganizationRequest;
    path: {
        Id: string;
    };
    query?: never;
    url: '/organizations/{Id}';
};

export type ChangeOrganizationPatchErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ChangeOrganizationPatchError = ChangeOrganizationPatchErrors[keyof ChangeOrganizationPatchErrors];

export type ChangeOrganizationPatchResponses = {
    /**
     * Accepted
     */
    202: GetOrganizationResponse;
};

export type ChangeOrganizationPatchResponse = ChangeOrganizationPatchResponses[keyof ChangeOrganizationPatchResponses];

export type ChangeOrganizationPutData = {
    body?: ChangeOrganizationRequest;
    path: {
        Id: string;
    };
    query?: never;
    url: '/organizations/{Id}';
};

export type ChangeOrganizationPutErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ChangeOrganizationPutError = ChangeOrganizationPutErrors[keyof ChangeOrganizationPutErrors];

export type ChangeOrganizationPutResponses = {
    /**
     * Accepted
     */
    202: GetOrganizationResponse;
};

export type ChangeOrganizationPutResponse = ChangeOrganizationPutResponses[keyof ChangeOrganizationPutResponses];

export type CreateOrganizationData = {
    body?: CreateOrganizationRequest;
    path?: never;
    query?: never;
    url: '/organizations';
};

export type CreateOrganizationErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * This user's email address is not allowed to create a shared organization, it may be a personal email address. It must be a company email address
     */
    405: unknown;
    /**
     * Another user has already claimed an organization with the same company email address as yours
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type CreateOrganizationError = CreateOrganizationErrors[keyof CreateOrganizationErrors];

export type CreateOrganizationResponses = {
    /**
     * Created
     */
    201: GetOrganizationResponse;
};

export type CreateOrganizationResponse = CreateOrganizationResponses[keyof CreateOrganizationResponses];

export type GetOrganizationSettingsData = {
    body?: never;
    path: {
        Id: string;
    };
    query?: never;
    url: '/organizations/{Id}/settings';
};

export type GetOrganizationSettingsErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type GetOrganizationSettingsError = GetOrganizationSettingsErrors[keyof GetOrganizationSettingsErrors];

export type GetOrganizationSettingsResponses = {
    /**
     * OK
     */
    200: GetOrganizationSettingsResponse;
};

export type GetOrganizationSettingsResponse2 = GetOrganizationSettingsResponses[keyof GetOrganizationSettingsResponses];

export type ListMembersForOrganizationData = {
    body?: never;
    path: {
        Id: string;
    };
    query?: {
        /**
         * List of child resources to embed in the resource
         */
        Embed?: string;
        /**
         * List of fields to include and exclude in the search result
         */
        Filter?: string;
        /**
         * The maximum number of search results to return
         */
        Limit?: number;
        /**
         * The zero-based index of the first search result
         */
        Offset?: number;
        /**
         * List of fields to sort the results on
         */
        Sort?: string;
    };
    url: '/organizations/{Id}/members';
};

export type ListMembersForOrganizationErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ListMembersForOrganizationError = ListMembersForOrganizationErrors[keyof ListMembersForOrganizationErrors];

export type ListMembersForOrganizationResponses = {
    /**
     * OK
     */
    200: ListMembersForOrganizationResponse;
};

export type ListMembersForOrganizationResponse2 = ListMembersForOrganizationResponses[keyof ListMembersForOrganizationResponses];

export type InviteMemberToOrganizationData = {
    body?: InviteMemberToOrganizationRequest;
    path: {
        Id: string;
    };
    query?: never;
    url: '/organizations/{Id}/members';
};

export type InviteMemberToOrganizationErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * The inviter is not an owner of the organization
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type InviteMemberToOrganizationError = InviteMemberToOrganizationErrors[keyof InviteMemberToOrganizationErrors];

export type InviteMemberToOrganizationResponses = {
    /**
     * Created
     */
    201: InviteMemberToOrganizationResponse;
};

export type InviteMemberToOrganizationResponse2 = InviteMemberToOrganizationResponses[keyof InviteMemberToOrganizationResponses];

export type UnassignRolesFromOrganizationPatchData = {
    body?: UnassignRolesFromOrganizationRequest;
    path: {
        Id: string;
    };
    query?: never;
    url: '/organizations/{Id}/roles/unassign';
};

export type UnassignRolesFromOrganizationPatchErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * The assigner is not an owner of the organization
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type UnassignRolesFromOrganizationPatchError = UnassignRolesFromOrganizationPatchErrors[keyof UnassignRolesFromOrganizationPatchErrors];

export type UnassignRolesFromOrganizationPatchResponses = {
    /**
     * Accepted
     */
    202: GetOrganizationResponse;
};

export type UnassignRolesFromOrganizationPatchResponse = UnassignRolesFromOrganizationPatchResponses[keyof UnassignRolesFromOrganizationPatchResponses];

export type UnassignRolesFromOrganizationPutData = {
    body?: UnassignRolesFromOrganizationRequest;
    path: {
        Id: string;
    };
    query?: never;
    url: '/organizations/{Id}/roles/unassign';
};

export type UnassignRolesFromOrganizationPutErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * The assigner is not an owner of the organization
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type UnassignRolesFromOrganizationPutError = UnassignRolesFromOrganizationPutErrors[keyof UnassignRolesFromOrganizationPutErrors];

export type UnassignRolesFromOrganizationPutResponses = {
    /**
     * Accepted
     */
    202: GetOrganizationResponse;
};

export type UnassignRolesFromOrganizationPutResponse = UnassignRolesFromOrganizationPutResponses[keyof UnassignRolesFromOrganizationPutResponses];

export type UnInviteMemberFromOrganizationData = {
    body?: never;
    path: {
        UserId: string;
        Id: string;
    };
    query?: never;
    url: '/organizations/{Id}/members/{UserId}';
};

export type UnInviteMemberFromOrganizationErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * The inviter is not an owner of the organization, or the invited is a required member of the organization
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type UnInviteMemberFromOrganizationError = UnInviteMemberFromOrganizationErrors[keyof UnInviteMemberFromOrganizationErrors];

export type UnInviteMemberFromOrganizationResponses = {
    /**
     * No Content
     */
    204: UnInviteMemberFromOrganizationResponse;
};

export type UnInviteMemberFromOrganizationResponse2 = UnInviteMemberFromOrganizationResponses[keyof UnInviteMemberFromOrganizationResponses];

export type ListPricingPlansData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/pricing/plans';
};

export type ListPricingPlansErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ListPricingPlansError = ListPricingPlansErrors[keyof ListPricingPlansErrors];

export type ListPricingPlansResponses = {
    /**
     * OK
     */
    200: ListPricingPlansResponse;
};

export type ListPricingPlansResponse2 = ListPricingPlansResponses[keyof ListPricingPlansResponses];

export type DrainAllProvisioningsData = {
    body?: DrainAllProvisioningsRequest;
    path?: never;
    query?: never;
    url: '/provisioning/drain';
};

export type DrainAllProvisioningsErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type DrainAllProvisioningsError = DrainAllProvisioningsErrors[keyof DrainAllProvisioningsErrors];

export type DrainAllProvisioningsResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type DrainAllProvisioningsResponse = DrainAllProvisioningsResponses[keyof DrainAllProvisioningsResponses];

export type NotifyProvisioningData = {
    body?: NotifyProvisioningRequest;
    path?: never;
    query?: never;
    url: '/provisioning/notify';
};

export type NotifyProvisioningErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type NotifyProvisioningError = NotifyProvisioningErrors[keyof NotifyProvisioningErrors];

export type NotifyProvisioningResponses = {
    /**
     * Created
     */
    201: DeliverMessageResponse;
};

export type NotifyProvisioningResponse = NotifyProvisioningResponses[keyof NotifyProvisioningResponses];

export type RecordMeasureData = {
    body?: RecordMeasureRequest;
    path?: never;
    query?: never;
    url: '/record/measure';
};

export type RecordMeasureErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type RecordMeasureError = RecordMeasureErrors[keyof RecordMeasureErrors];

export type RecordMeasureResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type RecordMeasureResponse = RecordMeasureResponses[keyof RecordMeasureResponses];

export type RecordUseData = {
    body?: RecordUseRequest;
    path?: never;
    query?: never;
    url: '/record/use';
};

export type RecordUseErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type RecordUseError = RecordUseErrors[keyof RecordUseErrors];

export type RecordUseResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type RecordUseResponse = RecordUseResponses[keyof RecordUseResponses];

export type AuthenticateSingleSignOnData = {
    body?: AuthenticateSingleSignOnRequest;
    path?: never;
    query?: never;
    url: '/sso/auth';
};

export type AuthenticateSingleSignOnErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * The provider is not known, or the authorization code is invalid
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * The user's account is suspended or disabled, and cannot be authenticated or used
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type AuthenticateSingleSignOnError = AuthenticateSingleSignOnErrors[keyof AuthenticateSingleSignOnErrors];

export type AuthenticateSingleSignOnResponses = {
    /**
     * Created
     */
    201: AuthenticateResponse;
};

export type AuthenticateSingleSignOnResponse = AuthenticateSingleSignOnResponses[keyof AuthenticateSingleSignOnResponses];

export type ConfirmSmsDeliveredData = {
    body?: ConfirmSmsDeliveredRequest;
    path?: never;
    query?: never;
    url: '/smses/delivered';
};

export type ConfirmSmsDeliveredErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ConfirmSmsDeliveredError = ConfirmSmsDeliveredErrors[keyof ConfirmSmsDeliveredErrors];

export type ConfirmSmsDeliveredResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type ConfirmSmsDeliveredResponse = ConfirmSmsDeliveredResponses[keyof ConfirmSmsDeliveredResponses];

export type ConfirmSmsDeliveryFailedData = {
    body?: ConfirmSmsDeliveryFailedRequest;
    path?: never;
    query?: never;
    url: '/smses/failed';
};

export type ConfirmSmsDeliveryFailedErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ConfirmSmsDeliveryFailedError = ConfirmSmsDeliveryFailedErrors[keyof ConfirmSmsDeliveryFailedErrors];

export type ConfirmSmsDeliveryFailedResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type ConfirmSmsDeliveryFailedResponse = ConfirmSmsDeliveryFailedResponses[keyof ConfirmSmsDeliveryFailedResponses];

export type DrainAllSmsesData = {
    body?: DrainAllSmsesRequest;
    path?: never;
    query?: never;
    url: '/smses/drain';
};

export type DrainAllSmsesErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type DrainAllSmsesError = DrainAllSmsesErrors[keyof DrainAllSmsesErrors];

export type DrainAllSmsesResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type DrainAllSmsesResponse = DrainAllSmsesResponses[keyof DrainAllSmsesResponses];

export type SearchAllSmsDeliveriesData = {
    body?: never;
    path?: never;
    query?: {
        OrganizationId?: string;
        SinceUtc?: string;
        Tags?: string;
        /**
         * List of child resources to embed in the resource
         */
        Embed?: string;
        /**
         * List of fields to include and exclude in the search result
         */
        Filter?: string;
        /**
         * The maximum number of search results to return
         */
        Limit?: number;
        /**
         * The zero-based index of the first search result
         */
        Offset?: number;
        /**
         * List of fields to sort the results on
         */
        Sort?: string;
    };
    url: '/smses';
};

export type SearchAllSmsDeliveriesErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type SearchAllSmsDeliveriesError = SearchAllSmsDeliveriesErrors[keyof SearchAllSmsDeliveriesErrors];

export type SearchAllSmsDeliveriesResponses = {
    /**
     * OK
     */
    200: SearchAllSmsDeliveriesResponse;
};

export type SearchAllSmsDeliveriesResponse2 = SearchAllSmsDeliveriesResponses[keyof SearchAllSmsDeliveriesResponses];

export type SendSmsData = {
    body?: SendSmsRequest;
    path?: never;
    query?: never;
    url: '/smses/send';
};

export type SendSmsErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type SendSmsError = SendSmsErrors[keyof SendSmsErrors];

export type SendSmsResponses = {
    /**
     * Created
     */
    201: DeliverMessageResponse;
};

export type SendSmsResponse = SendSmsResponses[keyof SendSmsResponses];

export type CancelSubscriptionData = {
    body?: never;
    path: {
        Id: string;
    };
    query?: never;
    url: '/subscriptions/{Id}';
};

export type CancelSubscriptionErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type CancelSubscriptionError = CancelSubscriptionErrors[keyof CancelSubscriptionErrors];

export type CancelSubscriptionResponses = {
    /**
     * No Content
     */
    204: GetSubscriptionResponse;
};

export type CancelSubscriptionResponse = CancelSubscriptionResponses[keyof CancelSubscriptionResponses];

export type GetSubscriptionData = {
    body?: never;
    path: {
        Id: string;
    };
    query?: never;
    url: '/subscriptions/{Id}';
};

export type GetSubscriptionErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type GetSubscriptionError = GetSubscriptionErrors[keyof GetSubscriptionErrors];

export type GetSubscriptionResponses = {
    /**
     * OK
     */
    200: GetSubscriptionResponse;
};

export type GetSubscriptionResponse2 = GetSubscriptionResponses[keyof GetSubscriptionResponses];

export type ChangeSubscriptionPlanPatchData = {
    body?: ChangeSubscriptionPlanRequest;
    path: {
        Id: string;
    };
    query?: never;
    url: '/subscriptions/{Id}/plan';
};

export type ChangeSubscriptionPlanPatchErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ChangeSubscriptionPlanPatchError = ChangeSubscriptionPlanPatchErrors[keyof ChangeSubscriptionPlanPatchErrors];

export type ChangeSubscriptionPlanPatchResponses = {
    /**
     * Accepted
     */
    202: GetSubscriptionResponse;
};

export type ChangeSubscriptionPlanPatchResponse = ChangeSubscriptionPlanPatchResponses[keyof ChangeSubscriptionPlanPatchResponses];

export type ChangeSubscriptionPlanPutData = {
    body?: ChangeSubscriptionPlanRequest;
    path: {
        Id: string;
    };
    query?: never;
    url: '/subscriptions/{Id}/plan';
};

export type ChangeSubscriptionPlanPutErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ChangeSubscriptionPlanPutError = ChangeSubscriptionPlanPutErrors[keyof ChangeSubscriptionPlanPutErrors];

export type ChangeSubscriptionPlanPutResponses = {
    /**
     * Accepted
     */
    202: GetSubscriptionResponse;
};

export type ChangeSubscriptionPlanPutResponse = ChangeSubscriptionPlanPutResponses[keyof ChangeSubscriptionPlanPutResponses];

export type ForceCancelSubscriptionData = {
    body?: never;
    path: {
        Id: string;
    };
    query?: never;
    url: '/subscriptions/{Id}/force';
};

export type ForceCancelSubscriptionErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ForceCancelSubscriptionError = ForceCancelSubscriptionErrors[keyof ForceCancelSubscriptionErrors];

export type ForceCancelSubscriptionResponses = {
    /**
     * No Content
     */
    204: GetSubscriptionResponse;
};

export type ForceCancelSubscriptionResponse = ForceCancelSubscriptionResponses[keyof ForceCancelSubscriptionResponses];

export type SearchSubscriptionHistoryData = {
    body?: never;
    path: {
        Id: string;
    };
    query?: {
        FromUtc?: string;
        ToUtc?: string;
        /**
         * List of child resources to embed in the resource
         */
        Embed?: string;
        /**
         * List of fields to include and exclude in the search result
         */
        Filter?: string;
        /**
         * The maximum number of search results to return
         */
        Limit?: number;
        /**
         * The zero-based index of the first search result
         */
        Offset?: number;
        /**
         * List of fields to sort the results on
         */
        Sort?: string;
    };
    url: '/subscriptions/{Id}/invoices';
};

export type SearchSubscriptionHistoryErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type SearchSubscriptionHistoryError = SearchSubscriptionHistoryErrors[keyof SearchSubscriptionHistoryErrors];

export type SearchSubscriptionHistoryResponses = {
    /**
     * OK
     */
    200: SearchSubscriptionHistoryResponse;
};

export type SearchSubscriptionHistoryResponse2 = SearchSubscriptionHistoryResponses[keyof SearchSubscriptionHistoryResponses];

export type TransferSubscriptionPatchData = {
    body?: TransferSubscriptionRequest;
    path: {
        Id: string;
    };
    query?: never;
    url: '/subscriptions/{Id}/transfer';
};

export type TransferSubscriptionPatchErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type TransferSubscriptionPatchError = TransferSubscriptionPatchErrors[keyof TransferSubscriptionPatchErrors];

export type TransferSubscriptionPatchResponses = {
    /**
     * Accepted
     */
    202: GetSubscriptionResponse;
};

export type TransferSubscriptionPatchResponse = TransferSubscriptionPatchResponses[keyof TransferSubscriptionPatchResponses];

export type TransferSubscriptionPutData = {
    body?: TransferSubscriptionRequest;
    path: {
        Id: string;
    };
    query?: never;
    url: '/subscriptions/{Id}/transfer';
};

export type TransferSubscriptionPutErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type TransferSubscriptionPutError = TransferSubscriptionPutErrors[keyof TransferSubscriptionPutErrors];

export type TransferSubscriptionPutResponses = {
    /**
     * Accepted
     */
    202: GetSubscriptionResponse;
};

export type TransferSubscriptionPutResponse = TransferSubscriptionPutResponses[keyof TransferSubscriptionPutResponses];

export type GetCallerWithHmacTestingOnlyData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/testingonly/authn/hmac/get';
};

export type GetCallerWithHmacTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type GetCallerWithHmacTestingOnlyError = GetCallerWithHmacTestingOnlyErrors[keyof GetCallerWithHmacTestingOnlyErrors];

export type GetCallerWithHmacTestingOnlyResponses = {
    /**
     * OK
     */
    200: GetCallerTestingOnlyResponse;
};

export type GetCallerWithHmacTestingOnlyResponse = GetCallerWithHmacTestingOnlyResponses[keyof GetCallerWithHmacTestingOnlyResponses];

export type GetCallerWithTokenOrApiKeyTestingOnlyData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/testingonly/authn/token/get';
};

export type GetCallerWithTokenOrApiKeyTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type GetCallerWithTokenOrApiKeyTestingOnlyError = GetCallerWithTokenOrApiKeyTestingOnlyErrors[keyof GetCallerWithTokenOrApiKeyTestingOnlyErrors];

export type GetCallerWithTokenOrApiKeyTestingOnlyResponses = {
    /**
     * OK
     */
    200: GetCallerTestingOnlyResponse;
};

export type GetCallerWithTokenOrApiKeyTestingOnlyResponse = GetCallerWithTokenOrApiKeyTestingOnlyResponses[keyof GetCallerWithTokenOrApiKeyTestingOnlyResponses];

export type AuthorizeByAnonymousTestingOnlyData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/testingonly/authz/anonymous/get';
};

export type AuthorizeByAnonymousTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type AuthorizeByAnonymousTestingOnlyError = AuthorizeByAnonymousTestingOnlyErrors[keyof AuthorizeByAnonymousTestingOnlyErrors];

export type AuthorizeByAnonymousTestingOnlyResponses = {
    /**
     * OK
     */
    200: GetCallerTestingOnlyResponse;
};

export type AuthorizeByAnonymousTestingOnlyResponse = AuthorizeByAnonymousTestingOnlyResponses[keyof AuthorizeByAnonymousTestingOnlyResponses];

export type AuthorizeByFeatureTestingOnlyData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/testingonly/authz/feature/get';
};

export type AuthorizeByFeatureTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type AuthorizeByFeatureTestingOnlyError = AuthorizeByFeatureTestingOnlyErrors[keyof AuthorizeByFeatureTestingOnlyErrors];

export type AuthorizeByFeatureTestingOnlyResponses = {
    /**
     * OK
     */
    200: GetCallerTestingOnlyResponse;
};

export type AuthorizeByFeatureTestingOnlyResponse = AuthorizeByFeatureTestingOnlyResponses[keyof AuthorizeByFeatureTestingOnlyResponses];

export type AuthorizeByTokenWithRoleTestingOnlyData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/testingonly/authz/role/get';
};

export type AuthorizeByTokenWithRoleTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type AuthorizeByTokenWithRoleTestingOnlyError = AuthorizeByTokenWithRoleTestingOnlyErrors[keyof AuthorizeByTokenWithRoleTestingOnlyErrors];

export type AuthorizeByTokenWithRoleTestingOnlyResponses = {
    /**
     * OK
     */
    200: GetCallerTestingOnlyResponse;
};

export type AuthorizeByTokenWithRoleTestingOnlyResponse = AuthorizeByTokenWithRoleTestingOnlyResponses[keyof AuthorizeByTokenWithRoleTestingOnlyResponses];

export type ContentNegotiationsTestingOnlyData = {
    body?: never;
    path?: never;
    query?: {
        Format?: string;
    };
    url: '/testingonly/negotiations/get';
};

export type ContentNegotiationsTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ContentNegotiationsTestingOnlyError = ContentNegotiationsTestingOnlyErrors[keyof ContentNegotiationsTestingOnlyErrors];

export type ContentNegotiationsTestingOnlyResponses = {
    /**
     * OK
     */
    200: StringMessageTestingOnlyResponse;
};

export type ContentNegotiationsTestingOnlyResponse = ContentNegotiationsTestingOnlyResponses[keyof ContentNegotiationsTestingOnlyResponses];

export type DestroyAllRepositoriesData = {
    body?: DestroyAllRepositoriesRequest;
    path?: never;
    query?: never;
    url: '/testingonly/repositories/destroy';
};

export type DestroyAllRepositoriesErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type DestroyAllRepositoriesError = DestroyAllRepositoriesErrors[keyof DestroyAllRepositoriesErrors];

export type DestroyAllRepositoriesResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type DestroyAllRepositoriesResponse = DestroyAllRepositoriesResponses[keyof DestroyAllRepositoriesResponses];

export type DownloadStreamTestingOnlyData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/testingonly/download';
};

export type DownloadStreamTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type DownloadStreamTestingOnlyError = DownloadStreamTestingOnlyErrors[keyof DownloadStreamTestingOnlyErrors];

export type DownloadStreamTestingOnlyResponses = {
    /**
     * OK
     */
    200: Blob | File;
};

export type DownloadStreamTestingOnlyResponse = DownloadStreamTestingOnlyResponses[keyof DownloadStreamTestingOnlyResponses];

export type ErrorsErrorTestingOnlyData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/testingonly/errors/error';
};

export type ErrorsErrorTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ErrorsErrorTestingOnlyError = ErrorsErrorTestingOnlyErrors[keyof ErrorsErrorTestingOnlyErrors];

export type ErrorsErrorTestingOnlyResponses = {
    /**
     * OK
     */
    200: StringMessageTestingOnlyResponse;
};

export type ErrorsErrorTestingOnlyResponse = ErrorsErrorTestingOnlyResponses[keyof ErrorsErrorTestingOnlyResponses];

export type ErrorsThrowTestingOnlyData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/testingonly/errors/throws';
};

export type ErrorsThrowTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ErrorsThrowTestingOnlyError = ErrorsThrowTestingOnlyErrors[keyof ErrorsThrowTestingOnlyErrors];

export type ErrorsThrowTestingOnlyResponses = {
    /**
     * OK
     */
    200: StringMessageTestingOnlyResponse;
};

export type ErrorsThrowTestingOnlyResponse = ErrorsThrowTestingOnlyResponses[keyof ErrorsThrowTestingOnlyResponses];

export type FormatsTestingOnlyData = {
    body?: FormatsTestingOnlyRequest;
    path?: never;
    query?: never;
    url: '/testingonly/formats/roundtrip';
};

export type FormatsTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type FormatsTestingOnlyError = FormatsTestingOnlyErrors[keyof FormatsTestingOnlyErrors];

export type FormatsTestingOnlyResponses = {
    /**
     * Created
     */
    201: FormatsTestingOnlyResponse;
};

export type FormatsTestingOnlyResponse2 = FormatsTestingOnlyResponses[keyof FormatsTestingOnlyResponses];

export type GetWithSimpleArrayTestingOnlyData = {
    body?: never;
    path?: never;
    query?: {
        AnArray?: string;
    };
    url: '/testingonly/general/get/array';
};

export type GetWithSimpleArrayTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type GetWithSimpleArrayTestingOnlyError = GetWithSimpleArrayTestingOnlyErrors[keyof GetWithSimpleArrayTestingOnlyErrors];

export type GetWithSimpleArrayTestingOnlyResponses = {
    /**
     * OK
     */
    200: StringMessageTestingOnlyResponse;
};

export type GetWithSimpleArrayTestingOnlyResponse = GetWithSimpleArrayTestingOnlyResponses[keyof GetWithSimpleArrayTestingOnlyResponses];

export type PostWithEmptyBodyTestingOnlyData = {
    body?: PostWithEmptyBodyTestingOnlyRequest;
    path?: never;
    query?: never;
    url: '/testingonly/general/body/empty';
};

export type PostWithEmptyBodyTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type PostWithEmptyBodyTestingOnlyError = PostWithEmptyBodyTestingOnlyErrors[keyof PostWithEmptyBodyTestingOnlyErrors];

export type PostWithEmptyBodyTestingOnlyResponses = {
    /**
     * Created
     */
    201: StringMessageTestingOnlyResponse;
};

export type PostWithEmptyBodyTestingOnlyResponse = PostWithEmptyBodyTestingOnlyResponses[keyof PostWithEmptyBodyTestingOnlyResponses];

export type PostWithEmptyBodyAndRequiredPropertiesTestingOnlyData = {
    body?: PostWithEmptyBodyAndRequiredPropertiesTestingOnlyRequest;
    path?: never;
    query?: never;
    url: '/testingonly/general/body/empty/required';
};

export type PostWithEmptyBodyAndRequiredPropertiesTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type PostWithEmptyBodyAndRequiredPropertiesTestingOnlyError = PostWithEmptyBodyAndRequiredPropertiesTestingOnlyErrors[keyof PostWithEmptyBodyAndRequiredPropertiesTestingOnlyErrors];

export type PostWithEmptyBodyAndRequiredPropertiesTestingOnlyResponses = {
    /**
     * Created
     */
    201: StringMessageTestingOnlyResponse;
};

export type PostWithEmptyBodyAndRequiredPropertiesTestingOnlyResponse = PostWithEmptyBodyAndRequiredPropertiesTestingOnlyResponses[keyof PostWithEmptyBodyAndRequiredPropertiesTestingOnlyResponses];

export type PostWithRouteParamsAndEmptyBodyTestingOnlyData = {
    body?: PostWithRouteParamsAndEmptyBodyTestingOnlyRequest;
    path: {
        ANumberProperty: number;
        AStringProperty: string;
    };
    query?: never;
    url: '/testingonly/general/body/{astringproperty}/{anumberproperty}/route';
};

export type PostWithRouteParamsAndEmptyBodyTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type PostWithRouteParamsAndEmptyBodyTestingOnlyError = PostWithRouteParamsAndEmptyBodyTestingOnlyErrors[keyof PostWithRouteParamsAndEmptyBodyTestingOnlyErrors];

export type PostWithRouteParamsAndEmptyBodyTestingOnlyResponses = {
    /**
     * Created
     */
    201: StringMessageTestingOnlyResponse;
};

export type PostWithRouteParamsAndEmptyBodyTestingOnlyResponse = PostWithRouteParamsAndEmptyBodyTestingOnlyResponses[keyof PostWithRouteParamsAndEmptyBodyTestingOnlyResponses];

export type GetTestingOnlyData = {
    body?: never;
    path: {
        AnEnumRouteProperty: string;
        AnIntRouteProperty: number;
        AStringRouteProperty: string;
    };
    query?: {
        ACamelEnumProperty?: string;
        ACamelIntProperty?: number;
        ACamelStringProperty?: string;
        AnEnumProperty?: string;
        AnEnumQueryProperty?: string;
        AnIntProperty?: number;
        AnIntQueryProperty?: number;
        AStringProperty?: string;
        AStringQueryProperty?: string;
    };
    url: '/testingonly/general/get/a/{AnEnumRouteProperty}/b/{AnIntRouteProperty}/c/{AStringRouteProperty}';
};

export type GetTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type GetTestingOnlyError = GetTestingOnlyErrors[keyof GetTestingOnlyErrors];

export type GetTestingOnlyResponses = {
    /**
     * OK
     */
    200: GeneralTestingOnlyResponse;
};

export type GetTestingOnlyResponse = GetTestingOnlyResponses[keyof GetTestingOnlyResponses];

export type PostTestingOnlyData = {
    body?: PostTestingOnlyRequest;
    path: {
        AnEnumRouteProperty: string;
        AnIntRouteProperty: number;
        AStringRouteProperty: string;
    };
    query?: never;
    url: '/testingonly/general/post/a/{AnEnumRouteProperty}/b/{AnIntRouteProperty}/c/{AStringRouteProperty}';
};

export type PostTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type PostTestingOnlyError = PostTestingOnlyErrors[keyof PostTestingOnlyErrors];

export type PostTestingOnlyResponses = {
    /**
     * Created
     */
    201: GeneralTestingOnlyResponse;
};

export type PostTestingOnlyResponse = PostTestingOnlyResponses[keyof PostTestingOnlyResponses];

export type SearchTestingOnlyData = {
    body?: never;
    path: {
        AnEnumRouteProperty: string;
        AnIntRouteProperty: number;
        AStringRouteProperty: string;
    };
    query?: {
        ACamelEnumProperty?: string;
        ACamelIntProperty?: number;
        ACamelStringProperty?: string;
        AnEnumProperty?: string;
        AnEnumQueryProperty?: string;
        AnIntProperty?: number;
        AnIntQueryProperty?: number;
        AStringProperty?: string;
        AStringQueryProperty?: string;
        /**
         * List of child resources to embed in the resource
         */
        Embed?: string;
        /**
         * List of fields to include and exclude in the search result
         */
        Filter?: string;
        /**
         * The maximum number of search results to return
         */
        Limit?: number;
        /**
         * The zero-based index of the first search result
         */
        Offset?: number;
        /**
         * List of fields to sort the results on
         */
        Sort?: string;
    };
    url: '/testingonly/general/search/a/{AnEnumRouteProperty}/b/{AnIntRouteProperty}/c/{AStringRouteProperty}';
};

export type SearchTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type SearchTestingOnlyError = SearchTestingOnlyErrors[keyof SearchTestingOnlyErrors];

export type SearchTestingOnlyResponses = {
    /**
     * OK
     */
    200: SearchTestingOnlyResponse;
};

export type SearchTestingOnlyResponse2 = SearchTestingOnlyResponses[keyof SearchTestingOnlyResponses];

export type GetInsecureTestingOnlyData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/testingonly/security/none';
};

export type GetInsecureTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type GetInsecureTestingOnlyError = GetInsecureTestingOnlyErrors[keyof GetInsecureTestingOnlyErrors];

export type GetInsecureTestingOnlyResponses = {
    /**
     * OK
     */
    200: EmptyResponse;
};

export type GetInsecureTestingOnlyResponse = GetInsecureTestingOnlyResponses[keyof GetInsecureTestingOnlyResponses];

export type PostInsecureTestingOnlyData = {
    body?: PostInsecureTestingOnlyRequest;
    path?: never;
    query?: never;
    url: '/testingonly/security/none';
};

export type PostInsecureTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type PostInsecureTestingOnlyError = PostInsecureTestingOnlyErrors[keyof PostInsecureTestingOnlyErrors];

export type PostInsecureTestingOnlyResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type PostInsecureTestingOnlyResponse = PostInsecureTestingOnlyResponses[keyof PostInsecureTestingOnlyResponses];

export type GetTenantedTestingOnlyData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * An ID of the Organization. If not provided, the ID of the default organization of the authenticated user (if any) is used
         */
        OrganizationId?: string;
    };
    url: '/testingonly/tenanted';
};

export type GetTenantedTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type GetTenantedTestingOnlyError = GetTenantedTestingOnlyErrors[keyof GetTenantedTestingOnlyErrors];

export type GetTenantedTestingOnlyResponses = {
    /**
     * OK
     */
    200: GetTenantedTestingOnlyResponse;
};

export type GetTenantedTestingOnlyResponse2 = GetTenantedTestingOnlyResponses[keyof GetTenantedTestingOnlyResponses];

export type OpenApiPostFormUrlEncodedTestingOnlyData = {
    body?: {
        optionalField?: string;
        requiredField: string;
    };
    path: {
        Id: string;
    };
    query?: never;
    url: '/testingonly/openapi/{Id}/urlencoded';
};

export type OpenApiPostFormUrlEncodedTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type OpenApiPostFormUrlEncodedTestingOnlyError = OpenApiPostFormUrlEncodedTestingOnlyErrors[keyof OpenApiPostFormUrlEncodedTestingOnlyErrors];

export type OpenApiPostFormUrlEncodedTestingOnlyResponses = {
    /**
     * Created
     */
    201: OpenApiTestingOnlyResponse;
};

export type OpenApiPostFormUrlEncodedTestingOnlyResponse = OpenApiPostFormUrlEncodedTestingOnlyResponses[keyof OpenApiPostFormUrlEncodedTestingOnlyResponses];

export type OpenApiGetTestingOnlyData = {
    body?: never;
    path: {
        /**
         * anid
         */
        Id: string;
    };
    query: {
        /**
         * anoptionalfield
         */
        OptionalField?: string;
        /**
         * arequiredfield
         */
        RequiredField: string;
    };
    url: '/testingonly/openapi/{Id}';
};

export type OpenApiGetTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type OpenApiGetTestingOnlyError = OpenApiGetTestingOnlyErrors[keyof OpenApiGetTestingOnlyErrors];

export type OpenApiGetTestingOnlyResponses = {
    /**
     * OK
     */
    200: OpenApiTestingOnlyResponse;
};

export type OpenApiGetTestingOnlyResponse = OpenApiGetTestingOnlyResponses[keyof OpenApiGetTestingOnlyResponses];

export type OpenApiPutTestingOnlyPatchData = {
    body?: OpenApiPutTestingOnlyRequest;
    path: {
        /**
         * anid
         */
        Id: string;
    };
    query?: never;
    url: '/testingonly/openapi/{Id}';
};

export type OpenApiPutTestingOnlyPatchErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * a custom conflict response
     */
    409: unknown;
    /**
     * a special response
     */
    419: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type OpenApiPutTestingOnlyPatchError = OpenApiPutTestingOnlyPatchErrors[keyof OpenApiPutTestingOnlyPatchErrors];

export type OpenApiPutTestingOnlyPatchResponses = {
    /**
     * Accepted
     */
    202: OpenApiTestingOnlyResponse;
};

export type OpenApiPutTestingOnlyPatchResponse = OpenApiPutTestingOnlyPatchResponses[keyof OpenApiPutTestingOnlyPatchResponses];

export type OpenApiPostTestingOnlyData = {
    body?: OpenApiPostTestingOnlyRequest;
    path: {
        /**
         * anid
         */
        Id: string;
    };
    query?: never;
    url: '/testingonly/openapi/{Id}';
};

export type OpenApiPostTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * a custom conflict response which spills over to the next line
     */
    409: unknown;
    /**
     * a special response
     */
    419: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type OpenApiPostTestingOnlyError = OpenApiPostTestingOnlyErrors[keyof OpenApiPostTestingOnlyErrors];

export type OpenApiPostTestingOnlyResponses = {
    /**
     * Created
     */
    201: OpenApiTestingOnlyResponse;
};

export type OpenApiPostTestingOnlyResponse = OpenApiPostTestingOnlyResponses[keyof OpenApiPostTestingOnlyResponses];

export type OpenApiPutTestingOnlyPutData = {
    body?: OpenApiPutTestingOnlyRequest;
    path: {
        /**
         * anid
         */
        Id: string;
    };
    query?: never;
    url: '/testingonly/openapi/{Id}';
};

export type OpenApiPutTestingOnlyPutErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * a custom conflict response
     */
    409: unknown;
    /**
     * a special response
     */
    419: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type OpenApiPutTestingOnlyPutError = OpenApiPutTestingOnlyPutErrors[keyof OpenApiPutTestingOnlyPutErrors];

export type OpenApiPutTestingOnlyPutResponses = {
    /**
     * Accepted
     */
    202: OpenApiTestingOnlyResponse;
};

export type OpenApiPutTestingOnlyPutResponse = OpenApiPutTestingOnlyPutResponses[keyof OpenApiPutTestingOnlyPutResponses];

export type OpenApiPostMultiPartFormDataTestingOnlyData = {
    body?: {
        files: Array<Blob | File>;
        optionalField?: string;
        requiredField: string;
    };
    path: {
        Id: string;
    };
    query?: never;
    url: '/testingonly/openapi/{Id}/form-data';
};

export type OpenApiPostMultiPartFormDataTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type OpenApiPostMultiPartFormDataTestingOnlyError = OpenApiPostMultiPartFormDataTestingOnlyErrors[keyof OpenApiPostMultiPartFormDataTestingOnlyErrors];

export type OpenApiPostMultiPartFormDataTestingOnlyResponses = {
    /**
     * Created
     */
    201: OpenApiTestingOnlyResponse;
};

export type OpenApiPostMultiPartFormDataTestingOnlyResponse = OpenApiPostMultiPartFormDataTestingOnlyResponses[keyof OpenApiPostMultiPartFormDataTestingOnlyResponses];

export type GetWithRedirectTestingOnlyData = {
    body?: never;
    path?: never;
    query?: {
        Result?: string;
    };
    url: '/testingonly/redirect/get';
};

export type GetWithRedirectTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type GetWithRedirectTestingOnlyError = GetWithRedirectTestingOnlyErrors[keyof GetWithRedirectTestingOnlyErrors];

export type GetWithRedirectTestingOnlyResponses = {
    /**
     * OK
     */
    200: StringMessageTestingOnlyResponse;
};

export type GetWithRedirectTestingOnlyResponse = GetWithRedirectTestingOnlyResponses[keyof GetWithRedirectTestingOnlyResponses];

export type PostWithRedirectTestingOnlyData = {
    body?: PostWithRedirectTestingOnlyRequest;
    path?: never;
    query?: never;
    url: '/testingonly/redirect/post';
};

export type PostWithRedirectTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type PostWithRedirectTestingOnlyError = PostWithRedirectTestingOnlyErrors[keyof PostWithRedirectTestingOnlyErrors];

export type PostWithRedirectTestingOnlyResponses = {
    /**
     * Created
     */
    201: StringMessageTestingOnlyResponse;
};

export type PostWithRedirectTestingOnlyResponse = PostWithRedirectTestingOnlyResponses[keyof PostWithRedirectTestingOnlyResponses];

export type RequestCorrelationsTestingOnlyData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/testingonly/correlations/get';
};

export type RequestCorrelationsTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type RequestCorrelationsTestingOnlyError = RequestCorrelationsTestingOnlyErrors[keyof RequestCorrelationsTestingOnlyErrors];

export type RequestCorrelationsTestingOnlyResponses = {
    /**
     * OK
     */
    200: StringMessageTestingOnlyResponse;
};

export type RequestCorrelationsTestingOnlyResponse = RequestCorrelationsTestingOnlyResponses[keyof RequestCorrelationsTestingOnlyResponses];

export type StatusesDeleteTestingOnlyData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/testingonly/statuses/delete1';
};

export type StatusesDeleteTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type StatusesDeleteTestingOnlyError = StatusesDeleteTestingOnlyErrors[keyof StatusesDeleteTestingOnlyErrors];

export type StatusesDeleteTestingOnlyResponses = {
    /**
     * No Content
     */
    204: void;
};

export type StatusesDeleteTestingOnlyResponse = StatusesDeleteTestingOnlyResponses[keyof StatusesDeleteTestingOnlyResponses];

export type StatusesDeleteWithResponseTestingOnlyData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/testingonly/statuses/delete2';
};

export type StatusesDeleteWithResponseTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type StatusesDeleteWithResponseTestingOnlyError = StatusesDeleteWithResponseTestingOnlyErrors[keyof StatusesDeleteWithResponseTestingOnlyErrors];

export type StatusesDeleteWithResponseTestingOnlyResponses = {
    /**
     * No Content
     */
    204: StatusesTestingOnlyResponse;
};

export type StatusesDeleteWithResponseTestingOnlyResponse = StatusesDeleteWithResponseTestingOnlyResponses[keyof StatusesDeleteWithResponseTestingOnlyResponses];

export type StatusesGetTestingOnlyData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/testingonly/statuses/get';
};

export type StatusesGetTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type StatusesGetTestingOnlyError = StatusesGetTestingOnlyErrors[keyof StatusesGetTestingOnlyErrors];

export type StatusesGetTestingOnlyResponses = {
    /**
     * OK
     */
    200: StatusesTestingOnlyResponse;
};

export type StatusesGetTestingOnlyResponse = StatusesGetTestingOnlyResponses[keyof StatusesGetTestingOnlyResponses];

export type StatusesPostTestingOnlyData = {
    body?: StatusesPostTestingOnlyRequest;
    path?: never;
    query?: never;
    url: '/testingonly/statuses/post1';
};

export type StatusesPostTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type StatusesPostTestingOnlyError = StatusesPostTestingOnlyErrors[keyof StatusesPostTestingOnlyErrors];

export type StatusesPostTestingOnlyResponses = {
    /**
     * Created
     */
    201: StatusesTestingOnlyResponse;
};

export type StatusesPostTestingOnlyResponse = StatusesPostTestingOnlyResponses[keyof StatusesPostTestingOnlyResponses];

export type StatusesPostWithLocationTestingOnlyData = {
    body?: StatusesPostWithLocationTestingOnlyRequest;
    path?: never;
    query?: never;
    url: '/testingonly/statuses/post2';
};

export type StatusesPostWithLocationTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type StatusesPostWithLocationTestingOnlyError = StatusesPostWithLocationTestingOnlyErrors[keyof StatusesPostWithLocationTestingOnlyErrors];

export type StatusesPostWithLocationTestingOnlyResponses = {
    /**
     * Created
     */
    201: StatusesTestingOnlyResponse;
};

export type StatusesPostWithLocationTestingOnlyResponse = StatusesPostWithLocationTestingOnlyResponses[keyof StatusesPostWithLocationTestingOnlyResponses];

export type StatusesPutPatchTestingOnlyPatchData = {
    body?: StatusesPutPatchTestingOnlyRequest;
    path?: never;
    query?: never;
    url: '/testingonly/statuses/putpatch';
};

export type StatusesPutPatchTestingOnlyPatchErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type StatusesPutPatchTestingOnlyPatchError = StatusesPutPatchTestingOnlyPatchErrors[keyof StatusesPutPatchTestingOnlyPatchErrors];

export type StatusesPutPatchTestingOnlyPatchResponses = {
    /**
     * Accepted
     */
    202: StatusesTestingOnlyResponse;
};

export type StatusesPutPatchTestingOnlyPatchResponse = StatusesPutPatchTestingOnlyPatchResponses[keyof StatusesPutPatchTestingOnlyPatchResponses];

export type StatusesPutPatchTestingOnlyPutData = {
    body?: StatusesPutPatchTestingOnlyRequest;
    path?: never;
    query?: never;
    url: '/testingonly/statuses/putpatch';
};

export type StatusesPutPatchTestingOnlyPutErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type StatusesPutPatchTestingOnlyPutError = StatusesPutPatchTestingOnlyPutErrors[keyof StatusesPutPatchTestingOnlyPutErrors];

export type StatusesPutPatchTestingOnlyPutResponses = {
    /**
     * Accepted
     */
    202: StatusesTestingOnlyResponse;
};

export type StatusesPutPatchTestingOnlyPutResponse = StatusesPutPatchTestingOnlyPutResponses[keyof StatusesPutPatchTestingOnlyPutResponses];

export type StatusesSearchTestingOnlyData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/testingonly/statuses/search';
};

export type StatusesSearchTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type StatusesSearchTestingOnlyError = StatusesSearchTestingOnlyErrors[keyof StatusesSearchTestingOnlyErrors];

export type StatusesSearchTestingOnlyResponses = {
    /**
     * OK
     */
    200: StatusesTestingOnlySearchResponse;
};

export type StatusesSearchTestingOnlyResponse = StatusesSearchTestingOnlyResponses[keyof StatusesSearchTestingOnlyResponses];

export type ValidationsUnvalidatedTestingOnlyData = {
    body?: never;
    path?: never;
    query?: {
        Id?: string;
    };
    url: '/testingonly/validations/unvalidated';
};

export type ValidationsUnvalidatedTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ValidationsUnvalidatedTestingOnlyError = ValidationsUnvalidatedTestingOnlyErrors[keyof ValidationsUnvalidatedTestingOnlyErrors];

export type ValidationsUnvalidatedTestingOnlyResponses = {
    /**
     * OK
     */
    200: StringMessageTestingOnlyResponse;
};

export type ValidationsUnvalidatedTestingOnlyResponse = ValidationsUnvalidatedTestingOnlyResponses[keyof ValidationsUnvalidatedTestingOnlyResponses];

export type ValidationsValidatedGetTestingOnlyData = {
    body?: never;
    path: {
        Id: string;
    };
    query: {
        OptionalField?: string;
        RequiredField: string;
    };
    url: '/testingonly/validations/validated/{Id}';
};

export type ValidationsValidatedGetTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ValidationsValidatedGetTestingOnlyError = ValidationsValidatedGetTestingOnlyErrors[keyof ValidationsValidatedGetTestingOnlyErrors];

export type ValidationsValidatedGetTestingOnlyResponses = {
    /**
     * OK
     */
    200: StringMessageTestingOnlyResponse;
};

export type ValidationsValidatedGetTestingOnlyResponse = ValidationsValidatedGetTestingOnlyResponses[keyof ValidationsValidatedGetTestingOnlyResponses];

export type ValidationsValidatedPostTestingOnlyData = {
    body?: ValidationsValidatedPostTestingOnlyRequest;
    path: {
        Id: string;
    };
    query?: never;
    url: '/testingonly/validations/validated/{Id}';
};

export type ValidationsValidatedPostTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ValidationsValidatedPostTestingOnlyError = ValidationsValidatedPostTestingOnlyErrors[keyof ValidationsValidatedPostTestingOnlyErrors];

export type ValidationsValidatedPostTestingOnlyResponses = {
    /**
     * Created
     */
    201: StringMessageTestingOnlyResponse;
};

export type ValidationsValidatedPostTestingOnlyResponse = ValidationsValidatedPostTestingOnlyResponses[keyof ValidationsValidatedPostTestingOnlyResponses];

export type TwilioNotifyEmailWebhookEventData = {
    body?: Array<SendGridEvent>;
    path?: never;
    query?: never;
    url: '/webhooks/twilio/email';
};

export type TwilioNotifyEmailWebhookEventErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type TwilioNotifyEmailWebhookEventError = TwilioNotifyEmailWebhookEventErrors[keyof TwilioNotifyEmailWebhookEventErrors];

export type TwilioNotifyEmailWebhookEventResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type TwilioNotifyEmailWebhookEventResponse = TwilioNotifyEmailWebhookEventResponses[keyof TwilioNotifyEmailWebhookEventResponses];

export type TwilioNotifySmsWebhookEventData = {
    body?: {
        apiVersion?: string;
        errorCode?: string;
        from?: string;
        messageSid?: string;
        messageStatus?: unknown;
        rawDlrDoneDate?: number;
        smsStatus?: unknown;
        to?: string;
    };
    path?: never;
    query?: never;
    url: '/webhooks/twilio/sms';
};

export type TwilioNotifySmsWebhookEventErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type TwilioNotifySmsWebhookEventError = TwilioNotifySmsWebhookEventErrors[keyof TwilioNotifySmsWebhookEventErrors];

export type TwilioNotifySmsWebhookEventResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type TwilioNotifySmsWebhookEventResponse = TwilioNotifySmsWebhookEventResponses[keyof TwilioNotifySmsWebhookEventResponses];

export type DeliverUsageData = {
    body?: DeliverUsageRequest;
    path?: never;
    query?: never;
    url: '/usages/deliver';
};

export type DeliverUsageErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type DeliverUsageError = DeliverUsageErrors[keyof DeliverUsageErrors];

export type DeliverUsageResponses = {
    /**
     * Created
     */
    201: DeliverMessageResponse;
};

export type DeliverUsageResponse = DeliverUsageResponses[keyof DeliverUsageResponses];

export type DrainAllUsagesData = {
    body?: DrainAllUsagesRequest;
    path?: never;
    query?: never;
    url: '/usages/drain';
};

export type DrainAllUsagesErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type DrainAllUsagesError = DrainAllUsagesErrors[keyof DrainAllUsagesErrors];

export type DrainAllUsagesResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type DrainAllUsagesResponse = DrainAllUsagesResponses[keyof DrainAllUsagesResponses];

export type ChangeProfileContactAddressPatchData = {
    body?: ChangeProfileContactAddressRequest;
    path: {
        UserId: string;
    };
    query?: never;
    url: '/profiles/{UserId}/contact';
};

export type ChangeProfileContactAddressPatchErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ChangeProfileContactAddressPatchError = ChangeProfileContactAddressPatchErrors[keyof ChangeProfileContactAddressPatchErrors];

export type ChangeProfileContactAddressPatchResponses = {
    /**
     * Accepted
     */
    202: GetProfileResponse;
};

export type ChangeProfileContactAddressPatchResponse = ChangeProfileContactAddressPatchResponses[keyof ChangeProfileContactAddressPatchResponses];

export type ChangeProfileContactAddressPutData = {
    body?: ChangeProfileContactAddressRequest;
    path: {
        UserId: string;
    };
    query?: never;
    url: '/profiles/{UserId}/contact';
};

export type ChangeProfileContactAddressPutErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ChangeProfileContactAddressPutError = ChangeProfileContactAddressPutErrors[keyof ChangeProfileContactAddressPutErrors];

export type ChangeProfileContactAddressPutResponses = {
    /**
     * Accepted
     */
    202: GetProfileResponse;
};

export type ChangeProfileContactAddressPutResponse = ChangeProfileContactAddressPutResponses[keyof ChangeProfileContactAddressPutResponses];

export type ChangeProfilePatchData = {
    body?: ChangeProfileRequest;
    path: {
        UserId: string;
    };
    query?: never;
    url: '/profiles/{UserId}';
};

export type ChangeProfilePatchErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ChangeProfilePatchError = ChangeProfilePatchErrors[keyof ChangeProfilePatchErrors];

export type ChangeProfilePatchResponses = {
    /**
     * Accepted
     */
    202: GetProfileResponse;
};

export type ChangeProfilePatchResponse = ChangeProfilePatchResponses[keyof ChangeProfilePatchResponses];

export type ChangeProfilePutData = {
    body?: ChangeProfileRequest;
    path: {
        UserId: string;
    };
    query?: never;
    url: '/profiles/{UserId}';
};

export type ChangeProfilePutErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ChangeProfilePutError = ChangeProfilePutErrors[keyof ChangeProfilePutErrors];

export type ChangeProfilePutResponses = {
    /**
     * Accepted
     */
    202: GetProfileResponse;
};

export type ChangeProfilePutResponse = ChangeProfilePutResponses[keyof ChangeProfilePutResponses];

export type DeleteProfileAvatarData = {
    body?: never;
    path: {
        UserId: string;
    };
    query?: never;
    url: '/profiles/{UserId}/avatar';
};

export type DeleteProfileAvatarErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type DeleteProfileAvatarError = DeleteProfileAvatarErrors[keyof DeleteProfileAvatarErrors];

export type DeleteProfileAvatarResponses = {
    /**
     * No Content
     */
    204: DeleteProfileAvatarResponse;
};

export type DeleteProfileAvatarResponse2 = DeleteProfileAvatarResponses[keyof DeleteProfileAvatarResponses];

export type ChangeProfileAvatarPatchData = {
    body?: {
        files: Array<Blob | File>;
    };
    path: {
        UserId: string;
    };
    query?: never;
    url: '/profiles/{UserId}/avatar';
};

export type ChangeProfileAvatarPatchErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ChangeProfileAvatarPatchError = ChangeProfileAvatarPatchErrors[keyof ChangeProfileAvatarPatchErrors];

export type ChangeProfileAvatarPatchResponses = {
    /**
     * Accepted
     */
    202: ChangeProfileAvatarResponse;
};

export type ChangeProfileAvatarPatchResponse = ChangeProfileAvatarPatchResponses[keyof ChangeProfileAvatarPatchResponses];

export type ChangeProfileAvatarPutData = {
    body?: {
        files: Array<Blob | File>;
    };
    path: {
        UserId: string;
    };
    query?: never;
    url: '/profiles/{UserId}/avatar';
};

export type ChangeProfileAvatarPutErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ChangeProfileAvatarPutError = ChangeProfileAvatarPutErrors[keyof ChangeProfileAvatarPutErrors];

export type ChangeProfileAvatarPutResponses = {
    /**
     * Accepted
     */
    202: ChangeProfileAvatarResponse;
};

export type ChangeProfileAvatarPutResponse = ChangeProfileAvatarPutResponses[keyof ChangeProfileAvatarPutResponses];

export type GetProfileForCallerData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/profiles/me';
};

export type GetProfileForCallerErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type GetProfileForCallerError = GetProfileForCallerErrors[keyof GetProfileForCallerErrors];

export type GetProfileForCallerResponses = {
    /**
     * OK
     */
    200: GetProfileForCallerResponse;
};

export type GetProfileForCallerResponse2 = GetProfileForCallerResponses[keyof GetProfileForCallerResponses];
